import { Directive, Inject, Input, Injectable, EventEmitter, Component, forwardRef, ViewChild, Output, Renderer2, ElementRef, HostListener, HostBinding, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR, DefaultValueAccessor, FormControl, CheckboxControlValueAccessor, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subject, noop } from 'rxjs';
import { BsDatepickerConfig, BsLocaleService, BsDaterangepickerConfig, DatePickerComponent, BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { CommonModule } from '@angular/common';
import { HttpErrorResponse, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgSelectModule } from '@ng-select/ng-select';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { tap } from 'rxjs/operators';
import { TranslateModule } from '@ngx-translate/core';
import { QuillModule } from 'ngx-quill';
import { DomSanitizer } from '@angular/platform-browser';
import { TextareaAutosizeModule } from 'ngx-textarea-autosize';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { deLocale } from 'ngx-bootstrap/locale';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { PopoverModule } from 'ngx-bootstrap/popover';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/forms';
import * as ɵngcc3 from 'ngx-bootstrap/datepicker';
import * as ɵngcc4 from 'ngx-bootstrap/timepicker';
import * as ɵngcc5 from '@ngx-translate/core';
import * as ɵngcc6 from 'ngx-quill';
import * as ɵngcc7 from 'ngx-bootstrap/popover';
import * as ɵngcc8 from '@angular/platform-browser';

function InputComponent_bd_form_required_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-required", 12);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("required", ctx_r0.requiredMarker);
} }
function InputComponent_bd_form_tips_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-tips", 13);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("tips", ctx_r1.tips);
} }
function InputComponent_bd_form_counter_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-counter", 14);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("maxLength", ctx_r2.maxLength)("form", ctx_r2.formControl);
} }
function InputComponent_bd_form_readonly_label_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-readonly-label");
} }
function InputComponent_bd_form_addon_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-addon", 15);
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("text", ctx_r4.prepend);
} }
function InputComponent_bd_form_addon_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-addon", 16);
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("text", ctx_r5.append);
} }
function InputComponent_bd_form_counter_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-counter", 14);
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("maxLength", ctx_r6.maxLength)("form", ctx_r6.formControl);
} }
function InputComponent_bd_form_help_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-help", 17);
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("label", ctx_r7.help);
} }
const _c0 = function (a0, a1, a2) { return { "focus": a0, "has-errors": a1, "has-value": a2 }; };
const _c1 = ["dp"];
function DatepickerComponent_bd_form_required_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-required", 11);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("required", ctx_r0.requiredMarker);
} }
function DatepickerComponent_bd_form_tips_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-tips", 12);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("tips", ctx_r1.tips);
} }
function DatepickerComponent_bd_form_readonly_label_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-readonly-label");
} }
function DatepickerComponent_bd_form_addon_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-addon", 13);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("text", ctx_r3.prepend);
} }
function DatepickerComponent_bd_form_addon_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-addon", 14);
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("text", ctx_r5.append);
} }
function DatepickerComponent_bd_form_errors_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-errors", 15);
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("errors", ctx_r6.errors);
} }
function DatepickerComponent_bd_form_help_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-help", 16);
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("label", ctx_r7.help);
} }
const _c2 = function (a0, a1) { return { "has-errors": a0, "has-value": a1 }; };
function DaterangeComponent_bd_form_required_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-required", 10);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("required", ctx_r0.requiredMarker);
} }
function DaterangeComponent_bd_form_tips_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-tips", 11);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("tips", ctx_r1.tips);
} }
function DaterangeComponent_bd_form_readonly_label_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-readonly-label");
} }
function DaterangeComponent_bd_form_addon_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-addon", 12);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("text", ctx_r3.prepend);
} }
function DaterangeComponent_bd_form_addon_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-addon", 13);
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("text", ctx_r5.append);
} }
function DaterangeComponent_bd_form_errors_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-errors", 14);
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("errors", ctx_r6.errors);
} }
function DaterangeComponent_bd_form_help_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-help", 15);
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("label", ctx_r7.help);
} }
function TextareaComponent_bd_form_required_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-required", 11);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("required", ctx_r0.requiredMarker);
} }
function TextareaComponent_bd_form_tips_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-tips", 12);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("tips", ctx_r1.tips);
} }
function TextareaComponent_bd_form_counter_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-counter", 13);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("maxLength", ctx_r2.maxLength)("form", ctx_r2.formControl);
} }
function TextareaComponent_bd_form_readonly_label_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-readonly-label");
} }
function TextareaComponent_bd_form_addon_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-addon", 14);
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("text", ctx_r4.prepend);
} }
function TextareaComponent_bd_form_addon_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-addon", 15);
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("text", ctx_r5.append);
} }
function TextareaComponent_bd_form_errors_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-errors", 16);
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("errors", ctx_r6.errors);
} }
function TextareaComponent_bd_form_counter_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-counter", 13);
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("maxLength", ctx_r7.maxLength)("form", ctx_r7.formControl);
} }
function TextareaComponent_bd_form_help_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-help", 17);
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("label", ctx_r8.help);
} }
const _c3 = function (a0) { return { "has-errors": a0 }; };
const _c4 = function (a0, a1) { return { "btn-loading": a0, "btn-onSuccess": a1 }; };
const _c5 = ["*"];
function CheckboxComponent_span_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.label);
} }
function CheckboxComponent_bd_form_required_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-required", 9);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("required", ctx_r2.requiredMarker);
} }
function CheckboxComponent_bd_form_tips_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-tips", 10);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("tips", ctx_r3.tips);
} }
function CheckboxComponent_bd_form_errors_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-errors", 11);
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("errors", ctx_r4.errors);
} }
function CheckboxComponent_bd_form_help_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-help", 12);
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("label", ctx_r5.help);
} }
function CheckboxComponent_ng_template_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0, 1);
} }
const _c6 = [[["", "section", "after-input"]], [["", "section", "custom-label"]]];
const _c7 = ["[section=after-input]", "[section=custom-label]"];
function DatetimepickerComponent_bd_form_readonly_label_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-readonly-label");
} }
function FormLabelComponent_label_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 1);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMap(ctx_r0.options.classFormLabel);
    ɵngcc0.ɵɵpropertyInterpolate("for", ctx_r0.inputId);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.label);
} }
function FormErrorsComponent_ul_0_li_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const error_r2 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 1, error_r2), " ");
} }
function FormErrorsComponent_ul_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul");
    ɵngcc0.ɵɵtemplate(1, FormErrorsComponent_ul_0_li_1_Template, 3, 3, "li", 1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMap(ctx_r0.options.classFormError);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.errors);
} }
function FormHelpComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMap(ctx_r0.options.classFormHelp);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 4, ctx_r0.label), "\n");
} }
function RteComponent_bd_form_required_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-required", 10);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("required", ctx_r0.requiredMarker);
} }
function RteComponent_bd_form_tips_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-tips", 11);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("tips", ctx_r1.tips);
} }
function RteComponent_bd_form_counter_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-counter", 12);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("maxLength", ctx_r2.maxLength)("form", ctx_r2.formControl);
} }
function RteComponent_bd_form_readonly_label_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-readonly-label");
} }
function RteComponent_bd_form_errors_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-errors", 13);
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("errors", ctx_r5.errors);
} }
function RteComponent_bd_form_counter_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-counter", 12);
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("maxLength", ctx_r6.maxLength)("form", ctx_r6.formControl);
} }
function RteComponent_bd_form_help_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-help", 14);
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("label", ctx_r7.help);
} }
function FormTipsComponent_ng_container_0_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵelement(1, "i", 2);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const tip_r2 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate1("fas ", tip_r2.icon, "");
    ɵngcc0.ɵɵpropertyInterpolate("popover", ɵngcc0.ɵɵpipeBind1(2, 4, tip_r2.tooltip));
} }
function FormTipsComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, FormTipsComponent_ng_container_0_span_1_Template, 3, 6, "span", 1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.tips);
} }
function FormRequiredComponent_span_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 1);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMap(ctx_r0.options.classFormRequired);
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r0.requiredString, ɵngcc0.ɵɵsanitizeHtml);
} }
function TimepickerComponent_bd_form_required_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-required", 10);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("required", ctx_r0.requiredMarker);
} }
function TimepickerComponent_bd_form_tips_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-tips", 11);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("tips", ctx_r1.tips);
} }
function TimepickerComponent_bd_form_readonly_label_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-readonly-label");
} }
function TimepickerComponent_bd_form_addon_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-addon", 12);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("text", ctx_r3.prepend);
} }
function TimepickerComponent_bd_form_addon_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-addon", 13);
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("text", ctx_r4.append);
} }
function TimepickerComponent_bd_form_errors_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-errors", 14);
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("errors", ctx_r5.errors);
} }
function TimepickerComponent_bd_form_help_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-help", 15);
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("label", ctx_r6.help);
} }
function FormLabelIconComponent_i_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i");
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate2("", ctx_r0.font, " fa-", ctx_r0.icon, "");
} }
function RadioComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 6)(1, "label");
    ɵngcc0.ɵɵelement(2, "input", 7);
    ɵngcc0.ɵɵelementStart(3, "span");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd()()();
} if (rf & 2) {
    const option_r5 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap(ctx_r0.options.classFormLabel);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("formControlName", ctx_r0.fieldName);
    ɵngcc0.ɵɵproperty("value", option_r5.value);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(option_r5.label);
} }
function RadioComponent_bd_form_required_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-required", 8);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("required", ctx_r1.requiredMarker);
} }
function RadioComponent_bd_form_tips_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-tips", 9);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("tips", ctx_r2.tips);
} }
function RadioComponent_bd_form_errors_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-errors", 10);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("errors", ctx_r3.errors);
} }
function RadioComponent_bd_form_help_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bd-form-help", 11);
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("label", ctx_r4.help);
} }
const _c8 = [[["", "section", "after-input"]]];
const _c9 = ["[section=after-input]"];
class FormInputComponent {
    constructor(_options) {
        this._options = _options;
        this.displayErrors = false;
        this.ignoreTouchedForErrors = false;
        this.requiredMarker = false;
        this.disabled = false;
        this.readOnly = false;
        this.uniqueId = '_' + Math.random().toString(36).substr(2, 9);
        this.options = Object.assign({}, _options);
    }
    get errors() {
        let errors = [];
        if ((this.options.displayErrors || this.displayErrors)
            && this.formControl
            && (this.formControl.touched || this.ignoreTouchedForErrors)
            && this.formControl.errors) {
            return Object.keys(this.formControl.errors).map(key => {
                // If error is a remote error take the message directly
                if (key.substr(0, FormInputComponent.REMOTE_ERROR_PREFIX.length) == FormInputComponent.REMOTE_ERROR_PREFIX) {
                    return this.formControl.errors[key];
                }
                return FormInputComponent.ERROR_PREFIX + '.' + key;
            });
        }
        return [];
    }
    ngOnInit() {
        /**
         * Override default options
         */
        Object.assign(this.options, this.optionsOverride);
        /**
         * Subscribe to form errors
         */
        this.formErrorServiceSubscription = this.formErrorService.propertyError.subscribe(error => {
            if (this.formControl && this.formControl.root) {
                const control = this.formControl.root.get(error.property_path);
                const errorKey = this.getErrorKey(error.property_path);
                if (control && !control.hasError(errorKey)) {
                    control.setErrors(Object.assign(Object.assign({}, control.errors), { [errorKey]: error.message }));
                }
            }
        });
    }
    ngOnDestroy() {
        this.formErrorServiceSubscription.unsubscribe();
    }
    writeValue(value) {
        this.input.writeValue(value);
    }
    registerOnChange(fn) {
        this.input.registerOnChange(fn);
    }
    registerOnTouched(fn) {
        this.input.registerOnTouched(fn);
    }
    setDisabledState(isDisabled) {
        this.input.setDisabledState(isDisabled);
    }
    get inputGroupClass() {
        if (this.prepend) {
            return this.options.classFormInputGroup + ' ' + this.options.classFormInputGroup + '--prepend';
        }
        if (this.append) {
            return this.options.classFormInputGroup + ' ' + this.options.classFormInputGroup + '--append';
        }
        return '';
    }
    getErrorKey(propertyPath) {
        return FormInputComponent.REMOTE_ERROR_PREFIX + propertyPath.split('.').pop();
    }
    get focus() {
        return this._focus;
    }
    set focus(value) {
        this._focus = value;
    }
}
FormInputComponent.ɵfac = function FormInputComponent_Factory(t) { return new (t || FormInputComponent)(ɵngcc0.ɵɵdirectiveInject('FormUtilitiesOptions')); };
FormInputComponent.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: FormInputComponent, inputs: { displayErrors: "displayErrors", ignoreTouchedForErrors: "ignoreTouchedForErrors", requiredMarker: "requiredMarker", disabled: "disabled", readOnly: "readOnly", options: "options", optionsOverride: "optionsOverride", tips: "tips", help: "help", maxLength: "maxLength", append: "append", prepend: "prepend" } });
FormInputComponent.REMOTE_ERROR_PREFIX = 'remote_';
FormInputComponent.ERROR_PREFIX = 'form.errors';
FormInputComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: ['FormUtilitiesOptions',] }] }
];
FormInputComponent.propDecorators = {
    displayErrors: [{ type: Input }],
    ignoreTouchedForErrors: [{ type: Input }],
    requiredMarker: [{ type: Input }],
    optionsOverride: [{ type: Input }],
    options: [{ type: Input }],
    tips: [{ type: Input }],
    help: [{ type: Input }],
    maxLength: [{ type: Input }],
    append: [{ type: Input }],
    prepend: [{ type: Input }],
    disabled: [{ type: Input }],
    readOnly: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormInputComponent, [{
        type: Directive
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: ['FormUtilitiesOptions']
            }] }]; }, { displayErrors: [{
            type: Input
        }], ignoreTouchedForErrors: [{
            type: Input
        }], requiredMarker: [{
            type: Input
        }], disabled: [{
            type: Input
        }], readOnly: [{
            type: Input
        }], options: [{
            type: Input
        }], optionsOverride: [{
            type: Input
        }], tips: [{
            type: Input
        }], help: [{
            type: Input
        }], maxLength: [{
            type: Input
        }], append: [{
            type: Input
        }], prepend: [{
            type: Input
        }] }); })();

class FormErrorService {
    constructor() {
        this.propertyError = new Subject();
        this.formError = new Subject();
    }
}
FormErrorService.ɵfac = function FormErrorService_Factory(t) { return new (t || FormErrorService)(); };
FormErrorService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: FormErrorService, factory: FormErrorService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormErrorService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class InputComponent extends FormInputComponent {
    constructor(_options, formErrorService) {
        super(_options);
        this._options = _options;
        this.formErrorService = formErrorService;
        this.placeholder = '';
        this.autocomplete = '';
        this.type = 'text';
        this.step = '';
        this.disableErrors = false;
        this.readOnly = false;
        this.onInputKeypress = new EventEmitter();
        this.onInputChange = new EventEmitter();
        this.onInputKeyup = new EventEmitter();
        this.onFocus = new EventEmitter();
        this.onFocusOut = new EventEmitter();
        this.onIconClicked = new EventEmitter();
    }
    handleOnInputKeypress(value) {
        this.onInputKeypress.emit(value);
    }
    handleOnInputChange(value) {
        this.onInputChange.emit(value);
    }
    handleOnInputKeyup(value) {
        this.onInputKeyup.emit(value);
    }
    handleOnFocus(value) {
        this.focus = true;
        this.onFocus.emit(value);
    }
    handleOnFocusOut(value) {
        this.focus = false;
        this.onFocusOut.emit(value);
    }
    handleIconClicked(event) {
        this.onIconClicked.emit(event);
    }
}
InputComponent.ɵfac = function InputComponent_Factory(t) { return new (t || InputComponent)(ɵngcc0.ɵɵdirectiveInject('FormUtilitiesOptions'), ɵngcc0.ɵɵdirectiveInject(FormErrorService)); };
InputComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: InputComponent, selectors: [["bd-input"]], viewQuery: function InputComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(DefaultValueAccessor, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.input = _t.first);
    } }, inputs: { placeholder: "placeholder", autocomplete: "autocomplete", type: "type", step: "step", disableErrors: "disableErrors", readOnly: "readOnly", label: "label", inputClass: "inputClass", formControl: "formControl", icon: "icon" }, outputs: { onInputKeypress: "onInputKeypress", onInputChange: "onInputChange", onInputKeyup: "onInputKeyup", onFocus: "onFocus", onFocusOut: "onFocusOut", onIconClicked: "onIconClicked" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => InputComponent),
                multi: true
            }]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 16, vars: 41, consts: [[3, "ngClass"], [3, "label", "inputId"], [3, "required", 4, "ngIf"], [3, "tips", 4, "ngIf"], [3, "maxLength", "form", 4, "ngIf"], [3, "icon", "click"], [4, "ngIf"], ["position", "prepend", 3, "text", 4, "ngIf"], ["ngDefaultControl", "", 3, "type", "step", "placeholder", "autocomplete", "readonly", "focusout", "focus", "change", "keypress", "keyup"], ["position", "append", 3, "text", 4, "ngIf"], [3, "errors"], [3, "label", 4, "ngIf"], [3, "required"], [3, "tips"], [3, "maxLength", "form"], ["position", "prepend", 3, "text"], ["position", "append", 3, "text"], [3, "label"]], template: function InputComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div")(2, "div");
        ɵngcc0.ɵɵelement(3, "bd-form-label", 1);
        ɵngcc0.ɵɵtemplate(4, InputComponent_bd_form_required_4_Template, 1, 1, "bd-form-required", 2);
        ɵngcc0.ɵɵtemplate(5, InputComponent_bd_form_tips_5_Template, 1, 1, "bd-form-tips", 3);
        ɵngcc0.ɵɵtemplate(6, InputComponent_bd_form_counter_6_Template, 1, 2, "bd-form-counter", 4);
        ɵngcc0.ɵɵelementStart(7, "bd-form-label-icon", 5);
        ɵngcc0.ɵɵlistener("click", function InputComponent_Template_bd_form_label_icon_click_7_listener($event) { return ctx.handleIconClicked($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(8, InputComponent_bd_form_readonly_label_8_Template, 1, 0, "bd-form-readonly-label", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div");
        ɵngcc0.ɵɵtemplate(10, InputComponent_bd_form_addon_10_Template, 1, 1, "bd-form-addon", 7);
        ɵngcc0.ɵɵelementStart(11, "input", 8);
        ɵngcc0.ɵɵlistener("focusout", function InputComponent_Template_input_focusout_11_listener($event) { return ctx.handleOnFocusOut($event.target.value); })("focus", function InputComponent_Template_input_focus_11_listener($event) { return ctx.handleOnFocus($event.target.value); })("change", function InputComponent_Template_input_change_11_listener($event) { return ctx.handleOnInputChange($event.target.value); })("keypress", function InputComponent_Template_input_keypress_11_listener($event) { return ctx.handleOnInputKeypress($event.target.value); })("keyup", function InputComponent_Template_input_keyup_11_listener($event) { return ctx.handleOnInputKeyup($event.target.value); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(12, InputComponent_bd_form_addon_12_Template, 1, 1, "bd-form-addon", 9);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelement(13, "bd-form-errors", 10);
        ɵngcc0.ɵɵtemplate(14, InputComponent_bd_form_counter_14_Template, 1, 2, "bd-form-counter", 4);
        ɵngcc0.ɵɵtemplate(15, InputComponent_bd_form_help_15_Template, 1, 1, "bd-form-help", 11);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.options.classFormGroup);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction3(37, _c0, ctx.focus, ctx.errors.length, ctx.formControl.value));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap(ctx.options.classFromInput);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap(ctx.options.classFromLegend);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("label", ctx.label)("inputId", ctx.uniqueId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.requiredMarker);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.tips);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.maxLength && ctx.options.counterBefore);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("icon", ctx.icon);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.readOnly);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap(ctx.inputGroupClass);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.prepend);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMapInterpolate2("", ctx.options.classFormControl, " ", ctx.inputClass, "");
        ɵngcc0.ɵɵproperty("type", ctx.type)("step", ctx.step)("placeholder", ctx.placeholder)("autocomplete", ctx.autocomplete)("readonly", ctx.readOnly);
        ɵngcc0.ɵɵattribute("id", ctx.uniqueId)("maxlength", ctx.maxLength)("aria-label", ctx.placeholder);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.append);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("errors", ctx.errors);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.maxLength && !ctx.options.counterBefore);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.help);
    } }, directives: function () { return [ɵngcc1.NgClass, FormLabelComponent, ɵngcc1.NgIf, FormRequiredComponent, FormTipsComponent, FormCounterComponent, FormLabelIconComponent, FormReadonlyLabelComponent, FormAddonComponent, ɵngcc2.DefaultValueAccessor, FormErrorsComponent, FormHelpComponent]; }, encapsulation: 2 });
InputComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: ['FormUtilitiesOptions',] }] },
    { type: FormErrorService }
];
InputComponent.propDecorators = {
    input: [{ type: ViewChild, args: [DefaultValueAccessor, { static: true },] }],
    label: [{ type: Input }],
    inputClass: [{ type: Input }],
    placeholder: [{ type: Input }],
    autocomplete: [{ type: Input }],
    type: [{ type: Input }],
    step: [{ type: Input }],
    disableErrors: [{ type: Input }],
    formControl: [{ type: Input }],
    icon: [{ type: Input }],
    readOnly: [{ type: Input }],
    onInputKeypress: [{ type: Output }],
    onInputChange: [{ type: Output }],
    onInputKeyup: [{ type: Output }],
    onFocus: [{ type: Output }],
    onFocusOut: [{ type: Output }],
    onIconClicked: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InputComponent, [{
        type: Component,
        args: [{
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => InputComponent),
                        multi: true
                    }],
                selector: 'bd-input',
                template: "<div class=\"{{ options.classFormGroup }}\" [ngClass]=\"{'focus': focus, 'has-errors': errors.length, 'has-value': formControl.value}\">\n\n  <div class=\"{{ options.classFromInput }}\">\n\n    <div class=\"{{ options.classFromLegend }}\">\n\n      <bd-form-label [label]=\"label\" [inputId]=\"uniqueId\"></bd-form-label>\n      <bd-form-required [required]=\"requiredMarker\" *ngIf=\"requiredMarker\"></bd-form-required>\n      <bd-form-tips [tips]=\"tips\" *ngIf=\"tips\"></bd-form-tips>\n      <bd-form-counter [maxLength]=\"maxLength\" [form]=\"formControl\" *ngIf=\"maxLength && options.counterBefore\"></bd-form-counter>\n      <bd-form-label-icon [icon]=\"icon\" (click)=\"handleIconClicked($event)\"></bd-form-label-icon>\n      <bd-form-readonly-label *ngIf=\"readOnly\"></bd-form-readonly-label>\n    </div>\n\n    <div class=\"{{ inputGroupClass }}\">\n\n      <bd-form-addon [text]=\"prepend\" position=\"prepend\" *ngIf=\"prepend\"></bd-form-addon>\n\n      <input [type]=\"type\"\n             [step]=\"step\"\n             class=\"{{ options.classFormControl }} {{ inputClass }}\"\n             [placeholder]=\"placeholder\"\n             [autocomplete]=\"autocomplete\"\n             [attr.id]=\"uniqueId\"\n             [attr.maxlength]=\"maxLength\"\n             [attr.aria-label]=\"placeholder\"\n             (focusout)=\"handleOnFocusOut($event.target.value)\"\n             (focus)=\"handleOnFocus($event.target.value)\"\n             (change)=\"handleOnInputChange($event.target.value)\"\n             (keypress)=\"handleOnInputKeypress($event.target.value)\"\n             (keyup)=\"handleOnInputKeyup($event.target.value)\"\n             [readonly]=\"readOnly\"\n             ngDefaultControl>\n\n      <bd-form-addon [text]=\"append\" position=\"append\" *ngIf=\"append\"></bd-form-addon>\n\n    </div>\n  </div>\n\n  <bd-form-errors [errors]=\"errors\"></bd-form-errors>\n  <bd-form-counter [maxLength]=\"maxLength\" [form]=\"formControl\" *ngIf=\"maxLength && !options.counterBefore\"></bd-form-counter>\n  <bd-form-help [label]=\"help\" *ngIf=\"help\"></bd-form-help>\n</div>\n"
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: ['FormUtilitiesOptions']
            }] }, { type: FormErrorService }]; }, { placeholder: [{
            type: Input
        }], autocomplete: [{
            type: Input
        }], type: [{
            type: Input
        }], step: [{
            type: Input
        }], disableErrors: [{
            type: Input
        }], readOnly: [{
            type: Input
        }], onInputKeypress: [{
            type: Output
        }], onInputChange: [{
            type: Output
        }], onInputKeyup: [{
            type: Output
        }], onFocus: [{
            type: Output
        }], onFocusOut: [{
            type: Output
        }], onIconClicked: [{
            type: Output
        }], input: [{
            type: ViewChild,
            args: [DefaultValueAccessor, { static: true }]
        }], label: [{
            type: Input
        }], inputClass: [{
            type: Input
        }], formControl: [{
            type: Input
        }], icon: [{
            type: Input
        }] }); })();

class DatepickerComponent extends FormInputComponent {
    constructor(_options, formErrorService, langService) {
        super(_options);
        this._options = _options;
        this.formErrorService = formErrorService;
        this.langService = langService;
        this.triggers = 'click';
        this.placeholder = '';
        this.disableErrors = false;
        this.formControl = new FormControl('');
        this.bsConfig = new BsDatepickerConfig();
        this.bsMaxDate = null;
        this.bsMinDate = null;
        this.readOnly = false;
    }
    ngOnInit() {
        super.ngOnInit();
        this.bsLang ? this.langService.use(this.bsLang) : this.langService.use('en');
    }
}
DatepickerComponent.ɵfac = function DatepickerComponent_Factory(t) { return new (t || DatepickerComponent)(ɵngcc0.ɵɵdirectiveInject('FormUtilitiesOptions'), ɵngcc0.ɵɵdirectiveInject(FormErrorService), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.BsLocaleService)); };
DatepickerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DatepickerComponent, selectors: [["bd-datepicker"]], viewQuery: function DatepickerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(DefaultValueAccessor, 7);
        ɵngcc0.ɵɵviewQuery(_c1, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.input = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.datepicker = _t.first);
    } }, inputs: { triggers: "triggers", placeholder: "placeholder", disableErrors: "disableErrors", formControl: "formControl", bsConfig: "bsConfig", bsMaxDate: "bsMaxDate", bsMinDate: "bsMinDate", readOnly: "readOnly", label: "label", inputClass: "inputClass", bsValue: "bsValue", bsLang: "bsLang" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DatepickerComponent),
                multi: true
            }]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 14, vars: 40, consts: [[3, "ngClass"], [3, "label", "inputId"], [3, "required", 4, "ngIf"], [3, "tips", 4, "ngIf"], [4, "ngIf"], ["position", "prepend", 3, "text", 4, "ngIf"], ["type", "text", "bsDatepicker", "", 3, "bsConfig", "formControl", "placeholder", "triggers", "minDate", "maxDate", "bsValue", "readonly"], ["dp", ""], ["position", "append", 3, "text", 4, "ngIf"], [3, "errors", 4, "ngIf"], [3, "label", 4, "ngIf"], [3, "required"], [3, "tips"], ["position", "prepend", 3, "text"], ["position", "append", 3, "text"], [3, "errors"], [3, "label"]], template: function DatepickerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div")(2, "div");
        ɵngcc0.ɵɵelement(3, "bd-form-label", 1);
        ɵngcc0.ɵɵtemplate(4, DatepickerComponent_bd_form_required_4_Template, 1, 1, "bd-form-required", 2);
        ɵngcc0.ɵɵtemplate(5, DatepickerComponent_bd_form_tips_5_Template, 1, 1, "bd-form-tips", 3);
        ɵngcc0.ɵɵtemplate(6, DatepickerComponent_bd_form_readonly_label_6_Template, 1, 0, "bd-form-readonly-label", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div");
        ɵngcc0.ɵɵtemplate(8, DatepickerComponent_bd_form_addon_8_Template, 1, 1, "bd-form-addon", 5);
        ɵngcc0.ɵɵelement(9, "input", 6, 7);
        ɵngcc0.ɵɵtemplate(11, DatepickerComponent_bd_form_addon_11_Template, 1, 1, "bd-form-addon", 8);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵtemplate(12, DatepickerComponent_bd_form_errors_12_Template, 1, 1, "bd-form-errors", 9);
        ɵngcc0.ɵɵtemplate(13, DatepickerComponent_bd_form_help_13_Template, 1, 1, "bd-form-help", 10);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.options.classFormGroup);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(37, _c2, ctx.errors.length, ctx.formControl.value));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap(ctx.options.classFromInput);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap(ctx.options.classFromLegend);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("label", ctx.label)("inputId", ctx.uniqueId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.requiredMarker);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.tips);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.readOnly);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap(ctx.inputGroupClass);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.prepend);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMapInterpolate2("", ctx.options.classFormControl, " ", ctx.inputClass, "");
        ɵngcc0.ɵɵproperty("bsConfig", ctx.bsConfig)("formControl", ctx.formControl)("placeholder", ctx.placeholder)("triggers", ctx.triggers)("minDate", ctx.bsMinDate)("maxDate", ctx.bsMaxDate)("bsValue", ctx.bsValue)("readonly", ctx.readOnly);
        ɵngcc0.ɵɵattribute("id", ctx.uniqueId)("maxlength", ctx.maxLength)("aria-label", ctx.placeholder);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.append);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.errors);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.help);
    } }, directives: function () { return [ɵngcc1.NgClass, FormLabelComponent, ɵngcc1.NgIf, FormRequiredComponent, FormTipsComponent, FormReadonlyLabelComponent, FormAddonComponent, ɵngcc3.BsDatepickerInputDirective, ɵngcc2.DefaultValueAccessor, ɵngcc3.BsDatepickerDirective, ɵngcc2.NgControlStatus, ɵngcc2.FormControlDirective, ɵngcc2.MaxLengthValidator, FormErrorsComponent, FormHelpComponent]; }, encapsulation: 2 });
DatepickerComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: ['FormUtilitiesOptions',] }] },
    { type: FormErrorService },
    { type: BsLocaleService }
];
DatepickerComponent.propDecorators = {
    input: [{ type: ViewChild, args: [DefaultValueAccessor, { static: true },] }],
    label: [{ type: Input }],
    inputClass: [{ type: Input }],
    triggers: [{ type: Input }],
    placeholder: [{ type: Input }],
    disableErrors: [{ type: Input }],
    bsValue: [{ type: Input }],
    formControl: [{ type: Input }],
    bsConfig: [{ type: Input }],
    bsLang: [{ type: Input }],
    bsMaxDate: [{ type: Input }],
    bsMinDate: [{ type: Input }],
    readOnly: [{ type: Input }],
    datepicker: [{ type: ViewChild, args: ['dp', { static: false },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DatepickerComponent, [{
        type: Component,
        args: [{
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DatepickerComponent),
                        multi: true
                    }],
                selector: 'bd-datepicker',
                template: "<div class=\"{{ options.classFormGroup }}\" [ngClass]=\"{'has-errors': errors.length, 'has-value': formControl.value}\">\n\n  <div class=\"{{ options.classFromInput }}\">\n\n    <div class=\"{{ options.classFromLegend }}\">\n\n      <bd-form-label [label]=\"label\" [inputId]=\"uniqueId\"></bd-form-label>\n      <bd-form-required [required]=\"requiredMarker\" *ngIf=\"requiredMarker\"></bd-form-required>\n      <bd-form-tips [tips]=\"tips\" *ngIf=\"tips\"></bd-form-tips>\n      <bd-form-readonly-label *ngIf=\"readOnly\"></bd-form-readonly-label>\n    </div>\n\n    <div class=\"{{ inputGroupClass }}\">\n\n      <bd-form-addon [text]=\"prepend\" position=\"prepend\" *ngIf=\"prepend\"></bd-form-addon>\n\n      <input #dp\n             type=\"text\"\n             class=\"{{ options.classFormControl }} {{ inputClass }}\"\n             bsDatepicker\n             [bsConfig]=\"bsConfig\"\n             [formControl]=\"formControl\"\n             [placeholder]=\"placeholder\"\n             [attr.id]=\"uniqueId\"\n             [triggers]=\"triggers\"\n             [attr.maxlength]=\"maxLength\"\n             [attr.aria-label]=\"placeholder\"\n             [minDate]=\"bsMinDate\"\n             [maxDate]=\"bsMaxDate\"\n             [bsValue]=\"bsValue\"\n             [readonly]=\"readOnly\"\n             >\n\n      <bd-form-addon [text]=\"append\" position=\"append\" *ngIf=\"append\"></bd-form-addon>\n\n    </div>\n  </div>\n\n  <bd-form-errors [errors]=\"errors\" *ngIf=\"errors\"></bd-form-errors>\n  <bd-form-help [label]=\"help\" *ngIf=\"help\"></bd-form-help>\n</div>\n"
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: ['FormUtilitiesOptions']
            }] }, { type: FormErrorService }, { type: ɵngcc3.BsLocaleService }]; }, { triggers: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], disableErrors: [{
            type: Input
        }], formControl: [{
            type: Input
        }], bsConfig: [{
            type: Input
        }], bsMaxDate: [{
            type: Input
        }], bsMinDate: [{
            type: Input
        }], readOnly: [{
            type: Input
        }], input: [{
            type: ViewChild,
            args: [DefaultValueAccessor, { static: true }]
        }], label: [{
            type: Input
        }], inputClass: [{
            type: Input
        }], bsValue: [{
            type: Input
        }], bsLang: [{
            type: Input
        }], datepicker: [{
            type: ViewChild,
            args: ['dp', { static: false }]
        }] }); })();

class DaterangeComponent extends FormInputComponent {
    constructor(_options, formErrorService, langService) {
        super(_options);
        this._options = _options;
        this.formErrorService = formErrorService;
        this.langService = langService;
        this.triggers = 'click';
        this.placeholder = '';
        this.disableErrors = false;
        this.formControl = new FormControl('');
        this.bsConfig = new BsDaterangepickerConfig();
        this.bsMaxDate = null;
        this.bsMinDate = null;
        this.readOnly = false;
        this.datesPicked = new EventEmitter();
    }
    ngOnInit() {
        super.ngOnInit();
        this.bsLang ? this.langService.use(this.bsLang) : this.langService.use('en');
    }
    handleOutputDates(event) {
        if (event) {
            this.datesPicked.emit(event);
        }
    }
}
DaterangeComponent.ɵfac = function DaterangeComponent_Factory(t) { return new (t || DaterangeComponent)(ɵngcc0.ɵɵdirectiveInject('FormUtilitiesOptions'), ɵngcc0.ɵɵdirectiveInject(FormErrorService), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.BsLocaleService)); };
DaterangeComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DaterangeComponent, selectors: [["bd-daterange"]], viewQuery: function DaterangeComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(DefaultValueAccessor, 7);
        ɵngcc0.ɵɵviewQuery(_c1, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.input = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.daterange = _t.first);
    } }, inputs: { triggers: "triggers", placeholder: "placeholder", disableErrors: "disableErrors", formControl: "formControl", bsConfig: "bsConfig", bsMaxDate: "bsMaxDate", bsMinDate: "bsMinDate", readOnly: "readOnly", label: "label", help: "help", inputClass: "inputClass", bsLang: "bsLang" }, outputs: { datesPicked: "datesPicked" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DaterangeComponent),
                multi: true
            }]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 14, vars: 35, consts: [[3, "label", "inputId"], [3, "required", 4, "ngIf"], [3, "tips", 4, "ngIf"], [4, "ngIf"], ["position", "prepend", 3, "text", 4, "ngIf"], ["type", "text", "bsDaterangepicker", "", 3, "bsConfig", "formControl", "placeholder", "triggers", "minDate", "maxDate", "readonly", "bsValueChange"], ["dp", ""], ["position", "append", 3, "text", 4, "ngIf"], [3, "errors", 4, "ngIf"], [3, "label", 4, "ngIf"], [3, "required"], [3, "tips"], ["position", "prepend", 3, "text"], ["position", "append", 3, "text"], [3, "errors"], [3, "label"]], template: function DaterangeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div")(1, "div")(2, "div");
        ɵngcc0.ɵɵelement(3, "bd-form-label", 0);
        ɵngcc0.ɵɵtemplate(4, DaterangeComponent_bd_form_required_4_Template, 1, 1, "bd-form-required", 1);
        ɵngcc0.ɵɵtemplate(5, DaterangeComponent_bd_form_tips_5_Template, 1, 1, "bd-form-tips", 2);
        ɵngcc0.ɵɵtemplate(6, DaterangeComponent_bd_form_readonly_label_6_Template, 1, 0, "bd-form-readonly-label", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div");
        ɵngcc0.ɵɵtemplate(8, DaterangeComponent_bd_form_addon_8_Template, 1, 1, "bd-form-addon", 4);
        ɵngcc0.ɵɵelementStart(9, "input", 5, 6);
        ɵngcc0.ɵɵlistener("bsValueChange", function DaterangeComponent_Template_input_bsValueChange_9_listener($event) { return ctx.handleOutputDates($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(11, DaterangeComponent_bd_form_addon_11_Template, 1, 1, "bd-form-addon", 7);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵtemplate(12, DaterangeComponent_bd_form_errors_12_Template, 1, 1, "bd-form-errors", 8);
        ɵngcc0.ɵɵtemplate(13, DaterangeComponent_bd_form_help_13_Template, 1, 1, "bd-form-help", 9);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.options.classFormGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap(ctx.options.classFromInput);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap(ctx.options.classFromLegend);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("label", ctx.label)("inputId", ctx.uniqueId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.requiredMarker);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.tips);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.readOnly);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap(ctx.inputGroupClass);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.prepend);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMapInterpolate2("", ctx.options.classFormControl, " ", ctx.inputClass, "");
        ɵngcc0.ɵɵproperty("bsConfig", ctx.bsConfig)("formControl", ctx.formControl)("placeholder", ctx.placeholder)("triggers", ctx.triggers)("minDate", ctx.bsMinDate)("maxDate", ctx.bsMaxDate)("readonly", ctx.readOnly);
        ɵngcc0.ɵɵattribute("id", ctx.uniqueId)("maxlength", ctx.maxLength)("aria-label", ctx.placeholder);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.append);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.errors);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.help);
    } }, directives: function () { return [FormLabelComponent, ɵngcc1.NgIf, FormRequiredComponent, FormTipsComponent, FormReadonlyLabelComponent, FormAddonComponent, ɵngcc3.BsDaterangepickerInputDirective, ɵngcc2.DefaultValueAccessor, ɵngcc3.BsDaterangepickerDirective, ɵngcc2.NgControlStatus, ɵngcc2.FormControlDirective, ɵngcc2.MaxLengthValidator, FormErrorsComponent, FormHelpComponent]; }, encapsulation: 2 });
DaterangeComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: ['FormUtilitiesOptions',] }] },
    { type: FormErrorService },
    { type: BsLocaleService }
];
DaterangeComponent.propDecorators = {
    input: [{ type: ViewChild, args: [DefaultValueAccessor, { static: true },] }],
    label: [{ type: Input }],
    help: [{ type: Input }],
    inputClass: [{ type: Input }],
    triggers: [{ type: Input }],
    placeholder: [{ type: Input }],
    disableErrors: [{ type: Input }],
    formControl: [{ type: Input }],
    bsConfig: [{ type: Input }],
    bsLang: [{ type: Input }],
    bsMaxDate: [{ type: Input }],
    bsMinDate: [{ type: Input }],
    readOnly: [{ type: Input }],
    daterange: [{ type: ViewChild, args: ['dp', { static: false },] }],
    datesPicked: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DaterangeComponent, [{
        type: Component,
        args: [{
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DaterangeComponent),
                        multi: true
                    }],
                selector: 'bd-daterange',
                template: "<div class=\"{{ options.classFormGroup }}\">\n  <div class=\"{{ options.classFromInput }}\">\n    <div class=\"{{ options.classFromLegend }}\">\n      <bd-form-label [label]=\"label\" [inputId]=\"uniqueId\"></bd-form-label>\n      <bd-form-required [required]=\"requiredMarker\" *ngIf=\"requiredMarker\"></bd-form-required>\n      <bd-form-tips [tips]=\"tips\" *ngIf=\"tips\"></bd-form-tips>\n      <bd-form-readonly-label *ngIf=\"readOnly\"></bd-form-readonly-label>\n    </div>\n\n    <div class=\"{{ inputGroupClass }}\">\n      <bd-form-addon [text]=\"prepend\" position=\"prepend\" *ngIf=\"prepend\"></bd-form-addon>\n      <input #dp\n             type=\"text\"\n             class=\"{{ options.classFormControl }} {{ inputClass }}\"\n             bsDaterangepicker\n             [bsConfig]=\"bsConfig\"\n             [formControl]=\"formControl\"\n             [placeholder]=\"placeholder\"\n             [attr.id]=\"uniqueId\"\n             [triggers]=\"triggers\"\n             [attr.maxlength]=\"maxLength\"\n             [attr.aria-label]=\"placeholder\"\n             [minDate]=\"bsMinDate\"\n             [maxDate]=\"bsMaxDate\"\n             [readonly]=\"readOnly\"\n             (bsValueChange)=\"handleOutputDates($event)\"\n      >\n      <bd-form-addon [text]=\"append\" position=\"append\" *ngIf=\"append\"></bd-form-addon>\n    </div>\n  </div>\n\n  <bd-form-errors [errors]=\"errors\" *ngIf=\"errors\"></bd-form-errors>\n  <bd-form-help [label]=\"help\" *ngIf=\"help\"></bd-form-help>\n</div>\n"
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: ['FormUtilitiesOptions']
            }] }, { type: FormErrorService }, { type: ɵngcc3.BsLocaleService }]; }, { triggers: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], disableErrors: [{
            type: Input
        }], formControl: [{
            type: Input
        }], bsConfig: [{
            type: Input
        }], bsMaxDate: [{
            type: Input
        }], bsMinDate: [{
            type: Input
        }], readOnly: [{
            type: Input
        }], datesPicked: [{
            type: Output
        }], input: [{
            type: ViewChild,
            args: [DefaultValueAccessor, { static: true }]
        }], label: [{
            type: Input
        }], help: [{
            type: Input
        }], inputClass: [{
            type: Input
        }], bsLang: [{
            type: Input
        }], daterange: [{
            type: ViewChild,
            args: ['dp', { static: false }]
        }] }); })();

class TextareaComponent extends FormInputComponent {
    constructor(_options, formErrorService) {
        super(_options);
        this._options = _options;
        this.formErrorService = formErrorService;
        this.placeholder = '';
        this.disableErrors = false;
        this.readOnly = false;
    }
}
TextareaComponent.ɵfac = function TextareaComponent_Factory(t) { return new (t || TextareaComponent)(ɵngcc0.ɵɵdirectiveInject('FormUtilitiesOptions'), ɵngcc0.ɵɵdirectiveInject(FormErrorService)); };
TextareaComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TextareaComponent, selectors: [["bd-textarea"]], viewQuery: function TextareaComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(DefaultValueAccessor, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.input = _t.first);
    } }, inputs: { placeholder: "placeholder", disableErrors: "disableErrors", readOnly: "readOnly", label: "label", help: "help", inputClass: "inputClass", formControl: "formControl" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => TextareaComponent),
                multi: true
            }]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 16, vars: 36, consts: [[3, "ngClass"], [3, "label", "inputId"], [3, "required", 4, "ngIf"], [3, "tips", 4, "ngIf"], [3, "maxLength", "form", 4, "ngIf"], [4, "ngIf"], ["position", "prepend", 3, "text", 4, "ngIf"], ["ngDefaultControl", "", 3, "disabled", "placeholder", "readOnly"], ["position", "append", 3, "text", 4, "ngIf"], [3, "errors", 4, "ngIf"], [3, "label", 4, "ngIf"], [3, "required"], [3, "tips"], [3, "maxLength", "form"], ["position", "prepend", 3, "text"], ["position", "append", 3, "text"], [3, "errors"], [3, "label"]], template: function TextareaComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div")(2, "div");
        ɵngcc0.ɵɵelement(3, "bd-form-label", 1);
        ɵngcc0.ɵɵtemplate(4, TextareaComponent_bd_form_required_4_Template, 1, 1, "bd-form-required", 2);
        ɵngcc0.ɵɵtemplate(5, TextareaComponent_bd_form_tips_5_Template, 1, 1, "bd-form-tips", 3);
        ɵngcc0.ɵɵtemplate(6, TextareaComponent_bd_form_counter_6_Template, 1, 2, "bd-form-counter", 4);
        ɵngcc0.ɵɵtemplate(7, TextareaComponent_bd_form_readonly_label_7_Template, 1, 0, "bd-form-readonly-label", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div");
        ɵngcc0.ɵɵtemplate(9, TextareaComponent_bd_form_addon_9_Template, 1, 1, "bd-form-addon", 6);
        ɵngcc0.ɵɵelementStart(10, "textarea", 7);
        ɵngcc0.ɵɵtext(11, "      ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(12, TextareaComponent_bd_form_addon_12_Template, 1, 1, "bd-form-addon", 8);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵtemplate(13, TextareaComponent_bd_form_errors_13_Template, 1, 1, "bd-form-errors", 9);
        ɵngcc0.ɵɵtemplate(14, TextareaComponent_bd_form_counter_14_Template, 1, 2, "bd-form-counter", 4);
        ɵngcc0.ɵɵtemplate(15, TextareaComponent_bd_form_help_15_Template, 1, 1, "bd-form-help", 10);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.options.classFormGroup);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(34, _c3, ctx.errors.length));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap(ctx.options.classFromInput);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap(ctx.options.classFromLegend);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("label", ctx.label)("inputId", ctx.uniqueId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.requiredMarker);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.tips);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.maxLength && ctx.options.counterBefore);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.readOnly);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap(ctx.inputGroupClass);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.prepend);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMapInterpolate2("", ctx.options.classFormControl, " ", ctx.inputClass, "");
        ɵngcc0.ɵɵproperty("disabled", ctx.disabled)("placeholder", ctx.placeholder)("readOnly", ctx.formControl.disabled || ctx.readOnly);
        ɵngcc0.ɵɵattribute("id", ctx.uniqueId)("maxlength", ctx.maxLength)("aria-label", ctx.placeholder);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.append);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.errors);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.maxLength && !ctx.options.counterBefore);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.help);
    } }, directives: function () { return [ɵngcc1.NgClass, FormLabelComponent, ɵngcc1.NgIf, FormRequiredComponent, FormTipsComponent, FormCounterComponent, FormReadonlyLabelComponent, FormAddonComponent, ɵngcc2.DefaultValueAccessor, FormErrorsComponent, FormHelpComponent]; }, encapsulation: 2 });
TextareaComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: ['FormUtilitiesOptions',] }] },
    { type: FormErrorService }
];
TextareaComponent.propDecorators = {
    input: [{ type: ViewChild, args: [DefaultValueAccessor, { static: true },] }],
    label: [{ type: Input }],
    help: [{ type: Input }],
    inputClass: [{ type: Input }],
    placeholder: [{ type: Input }],
    disableErrors: [{ type: Input }],
    formControl: [{ type: Input }],
    readOnly: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TextareaComponent, [{
        type: Component,
        args: [{
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => TextareaComponent),
                        multi: true
                    }],
                selector: 'bd-textarea',
                template: "<div class=\"{{ options.classFormGroup }}\" [ngClass]=\"{'has-errors': errors.length}\">\n\n  <div class=\"{{ options.classFromInput }}\">\n\n    <div class=\"{{ options.classFromLegend }}\">\n\n      <bd-form-label [label]=\"label\" [inputId]=\"uniqueId\"></bd-form-label>\n      <bd-form-required [required]=\"requiredMarker\" *ngIf=\"requiredMarker\"></bd-form-required>\n      <bd-form-tips [tips]=\"tips\" *ngIf=\"tips\"></bd-form-tips>\n      <bd-form-counter [maxLength]=\"maxLength\" [form]=\"formControl\" *ngIf=\"maxLength && options.counterBefore\"></bd-form-counter>\n      <bd-form-readonly-label *ngIf=\"readOnly\"></bd-form-readonly-label>\n    </div>\n\n    <div class=\"{{ inputGroupClass }}\">\n\n      <bd-form-addon [text]=\"prepend\" position=\"prepend\" *ngIf=\"prepend\"></bd-form-addon>\n\n      <textarea [disabled]=\"disabled\"\n                class=\"{{ options.classFormControl }} {{ inputClass }}\"\n                [placeholder]=\"placeholder\"\n                [attr.id]=\"uniqueId\"\n                [attr.maxlength]=\"maxLength\"\n                [attr.aria-label]=\"placeholder\"\n                [readOnly]=\"formControl.disabled || readOnly\"\n                ngDefaultControl>\n      </textarea>\n\n      <bd-form-addon [text]=\"append\" position=\"append\" *ngIf=\"append\"></bd-form-addon>\n\n    </div>\n  </div>\n\n  <bd-form-errors [errors]=\"errors\" *ngIf=\"errors\"></bd-form-errors>\n  <bd-form-counter [maxLength]=\"maxLength\" [form]=\"formControl\" *ngIf=\"maxLength && !options.counterBefore\"></bd-form-counter>\n  <bd-form-help [label]=\"help\" *ngIf=\"help\"></bd-form-help>\n</div>\n"
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: ['FormUtilitiesOptions']
            }] }, { type: FormErrorService }]; }, { placeholder: [{
            type: Input
        }], disableErrors: [{
            type: Input
        }], readOnly: [{
            type: Input
        }], input: [{
            type: ViewChild,
            args: [DefaultValueAccessor, { static: true }]
        }], label: [{
            type: Input
        }], help: [{
            type: Input
        }], inputClass: [{
            type: Input
        }], formControl: [{
            type: Input
        }] }); })();

class ProgressButtonComponent {
    constructor() {
        this.btnClass = 'btn-primary';
        this.btnType = 'button';
        this.btnTargetForm = null;
        this.btnStateLoading = false;
        this.btnStateSuccess = false;
        this.btnDisabled = false;
        this.clicked = new EventEmitter();
    }
}
ProgressButtonComponent.ɵfac = function ProgressButtonComponent_Factory(t) { return new (t || ProgressButtonComponent)(); };
ProgressButtonComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ProgressButtonComponent, selectors: [["bd-progress-button"]], inputs: { btnClass: "btnClass", btnType: "btnType", btnTargetForm: "btnTargetForm", btnStateLoading: "btnStateLoading", btnStateSuccess: "btnStateSuccess", btnDisabled: "btnDisabled" }, outputs: { clicked: "clicked" }, ngContentSelectors: _c5, decls: 11, vars: 10, consts: [[3, "click"], [3, "disabled", "ngClass"], [1, "btn-loading"], [1, "loader"], [1, "btn-text"], [1, "btn-onSuccess"], [1, "fa", "fa-check"]], template: function ProgressButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("click", function ProgressButtonComponent_Template_div_click_0_listener() { return ctx.clicked.emit(null); });
        ɵngcc0.ɵɵelementStart(1, "button", 1)(2, "div", 2)(3, "span", 3);
        ɵngcc0.ɵɵelement(4, "span")(5, "span")(6, "span");
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(7, "div", 4);
        ɵngcc0.ɵɵprojection(8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 5);
        ɵngcc0.ɵɵelement(10, "i", 6);
        ɵngcc0.ɵɵelementEnd()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMapInterpolate1("btn btn-progress ", ctx.btnClass, "");
        ɵngcc0.ɵɵproperty("disabled", ctx.btnDisabled)("ngClass", ɵngcc0.ɵɵpureFunction2(7, _c4, ctx.btnStateLoading, ctx.btnStateSuccess));
        ɵngcc0.ɵɵattribute("type", ctx.btnType)("form", ctx.btnTargetForm);
    } }, directives: [ɵngcc1.NgClass], styles: ["[_nghost-%COMP%]   .button-progress[_ngcontent-%COMP%]{padding:0;min-height:40px;min-width:190px;overflow:hidden;position:relative}[_nghost-%COMP%]   .button-progress[_ngcontent-%COMP%]   .btn-text[_ngcontent-%COMP%]{padding:11px 2.5px;text-align:center}[_nghost-%COMP%]   .button-progress[_ngcontent-%COMP%]   .btn-loading[_ngcontent-%COMP%]{position:relative}[_nghost-%COMP%]   .button-progress[_ngcontent-%COMP%]   .btn-loading[_ngcontent-%COMP%]   .loader[_ngcontent-%COMP%]{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);display:inline-block;line-height:6px}[_nghost-%COMP%]   .button-progress[_ngcontent-%COMP%]   .btn-loading[_ngcontent-%COMP%]   .loader[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:inline-block;width:6px;height:6px;border-radius:50%;background:white;margin:0 3px;-webkit-animation:load .6s infinite;animation:load .6s infinite}[_nghost-%COMP%]   .button-progress[_ngcontent-%COMP%]   .btn-loading[_ngcontent-%COMP%]   .loader[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:nth-child(2){-webkit-animation-delay:.1s;animation-delay:.1s}[_nghost-%COMP%]   .button-progress[_ngcontent-%COMP%]   .btn-loading[_ngcontent-%COMP%]   .loader[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:nth-child(3){-webkit-animation-delay:.2s;animation-delay:.2s}[_nghost-%COMP%]   .button-progress[_ngcontent-%COMP%]   .btn-text[_ngcontent-%COMP%], [_nghost-%COMP%]   .button-progress[_ngcontent-%COMP%]   .btn-loading[_ngcontent-%COMP%], [_nghost-%COMP%]   .button-progress[_ngcontent-%COMP%]   .btn-success[_ngcontent-%COMP%]{display:block;transition:transform .2s ease-in-out,opacity .1s ease-in-out;position:absolute;top:0;left:0;right:0;bottom:0}[_nghost-%COMP%]   .button-progress[_ngcontent-%COMP%]   .btn-loading[_ngcontent-%COMP%]{transform:translateY(100%);opacity:0}[_nghost-%COMP%]   .button-progress[_ngcontent-%COMP%]   .btn-onSuccess[_ngcontent-%COMP%]{transform:translateY(100%);opacity:0}[_nghost-%COMP%]   .button-progress.btn-loading[_ngcontent-%COMP%]{pointer-events:none}[_nghost-%COMP%]   .button-progress.btn-loading[_ngcontent-%COMP%]   .btn-text[_ngcontent-%COMP%]{transform:translateY(-100%);opacity:0}[_nghost-%COMP%]   .button-progress.btn-loading[_ngcontent-%COMP%]   .btn-onSuccess[_ngcontent-%COMP%]{transform:translateY(-100%);opacity:0}[_nghost-%COMP%]   .button-progress.btn-loading[_ngcontent-%COMP%]   .btn-loading[_ngcontent-%COMP%]{transform:translate(0);opacity:1}[_nghost-%COMP%]   .button-progress.btn-onSuccess[_ngcontent-%COMP%]{pointer-events:none}[_nghost-%COMP%]   .button-progress.btn-onSuccess[_ngcontent-%COMP%]   .btn-text[_ngcontent-%COMP%]{transform:translateY(-100%);opacity:0}[_nghost-%COMP%]   .button-progress.btn-onSuccess[_ngcontent-%COMP%]   .btn-loading[_ngcontent-%COMP%]{transform:translateY(-100%);opacity:0}[_nghost-%COMP%]   .button-progress.btn-onSuccess[_ngcontent-%COMP%]   .btn-onSuccess[_ngcontent-%COMP%]{transform:translate(0);opacity:1}@-webkit-keyframes load{0%{opacity:.6;transform:scale(1)}30%{opacity:.7;transform:scale(1.1)}50%{opacity:1;transform:scale(1.4)}80%{opacity:.7;transform:scale(1.1)}to{opacity:.6;transform:scale(1)}}@keyframes load{0%{opacity:.6;transform:scale(1)}30%{opacity:.7;transform:scale(1.1)}50%{opacity:1;transform:scale(1.4)}80%{opacity:.7;transform:scale(1.1)}to{opacity:.6;transform:scale(1)}}"] });
ProgressButtonComponent.propDecorators = {
    btnClass: [{ type: Input }],
    btnType: [{ type: Input }],
    btnTargetForm: [{ type: Input }],
    btnStateLoading: [{ type: Input }],
    btnStateSuccess: [{ type: Input }],
    btnDisabled: [{ type: Input }],
    clicked: [{ type: Output, args: ['clicked',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ProgressButtonComponent, [{
        type: Component,
        args: [{
                selector: 'bd-progress-button',
                template: "<div (click)=\"clicked.emit(null)\">\n  <button class=\"btn btn-progress {{ btnClass }}\"\n          [attr.type]=\"btnType\"\n          [attr.form]=\"btnTargetForm\"\n          [disabled]=\"btnDisabled\"\n          [ngClass]=\"{'btn-loading': btnStateLoading, 'btn-onSuccess': btnStateSuccess}\"\n  >\n    <div class=\"btn-loading\">\n          <span class='loader'>\n              <span></span>\n              <span></span>\n              <span></span>\n          </span>\n    </div>\n    <div class=\"btn-text\">\n      <ng-content></ng-content>\n    </div>\n    <div class=\"btn-onSuccess\">\n      <i class=\"fa fa-check\"></i>\n    </div>\n  </button>\n</div>\n",
                styles: [":host .button-progress{padding:0;min-height:40px;min-width:190px;overflow:hidden;position:relative}:host .button-progress .btn-text{padding:11px 2.5px;text-align:center}:host .button-progress .btn-loading{position:relative}:host .button-progress .btn-loading .loader{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);display:inline-block;line-height:6px}:host .button-progress .btn-loading .loader span{display:inline-block;width:6px;height:6px;border-radius:50%;background:white;margin:0 3px;-webkit-animation:load .6s infinite;animation:load .6s infinite}:host .button-progress .btn-loading .loader span:nth-child(2){-webkit-animation-delay:.1s;animation-delay:.1s}:host .button-progress .btn-loading .loader span:nth-child(3){-webkit-animation-delay:.2s;animation-delay:.2s}:host .button-progress .btn-text,:host .button-progress .btn-loading,:host .button-progress .btn-success{display:block;transition:transform .2s ease-in-out,opacity .1s ease-in-out;position:absolute;top:0;left:0;right:0;bottom:0}:host .button-progress .btn-loading{transform:translateY(100%);opacity:0}:host .button-progress .btn-onSuccess{transform:translateY(100%);opacity:0}:host .button-progress.btn-loading{pointer-events:none}:host .button-progress.btn-loading .btn-text{transform:translateY(-100%);opacity:0}:host .button-progress.btn-loading .btn-onSuccess{transform:translateY(-100%);opacity:0}:host .button-progress.btn-loading .btn-loading{transform:translate(0);opacity:1}:host .button-progress.btn-onSuccess{pointer-events:none}:host .button-progress.btn-onSuccess .btn-text{transform:translateY(-100%);opacity:0}:host .button-progress.btn-onSuccess .btn-loading{transform:translateY(-100%);opacity:0}:host .button-progress.btn-onSuccess .btn-onSuccess{transform:translate(0);opacity:1}@-webkit-keyframes load{0%{opacity:.6;transform:scale(1)}30%{opacity:.7;transform:scale(1.1)}50%{opacity:1;transform:scale(1.4)}80%{opacity:.7;transform:scale(1.1)}to{opacity:.6;transform:scale(1)}}@keyframes load{0%{opacity:.6;transform:scale(1)}30%{opacity:.7;transform:scale(1.1)}50%{opacity:1;transform:scale(1.4)}80%{opacity:.7;transform:scale(1.1)}to{opacity:.6;transform:scale(1)}}\n"]
            }]
    }], function () { return []; }, { btnClass: [{
            type: Input
        }], btnType: [{
            type: Input
        }], btnTargetForm: [{
            type: Input
        }], btnStateLoading: [{
            type: Input
        }], btnStateSuccess: [{
            type: Input
        }], btnDisabled: [{
            type: Input
        }], clicked: [{
            type: Output,
            args: ['clicked']
        }] }); })();

class SelectDirective {
    constructor(_options, renderer, elementRef) {
        this._options = _options;
        this.renderer = renderer;
        this.elementRef = elementRef;
    }
    ngOnInit() {
        // Create a div with form-group
        const formGroupDiv = this.renderer.createElement('div');
        this.renderer.addClass(formGroupDiv, this._options.classFormGroup);
        if (this.label) {
            const label = this.renderer.createElement('label');
            const labelText = this.renderer.createText(this.label);
            this.renderer.addClass(label, this._options.classFormLabel);
            this.renderer.appendChild(label, labelText);
            this.renderer.appendChild(formGroupDiv, label);
        }
        this.renderer.insertBefore(this.elementRef.nativeElement.parentNode, formGroupDiv, this.elementRef.nativeElement);
        this.renderer.appendChild(formGroupDiv, this.elementRef.nativeElement);
    }
}
SelectDirective.ɵfac = function SelectDirective_Factory(t) { return new (t || SelectDirective)(ɵngcc0.ɵɵdirectiveInject('FormUtilitiesOptions'), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
SelectDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: SelectDirective, selectors: [["", "bdSelect", ""]], inputs: { label: "label" } });
SelectDirective.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: ['FormUtilitiesOptions',] }] },
    { type: Renderer2 },
    { type: ElementRef }
];
SelectDirective.propDecorators = {
    label: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SelectDirective, [{
        type: Directive,
        args: [{
                selector: '[bdSelect]'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: ['FormUtilitiesOptions']
            }] }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { label: [{
            type: Input
        }] }); })();

class FormErrorInterceptor {
    constructor(formErrorService) {
        this.formErrorService = formErrorService;
    }
    intercept(req, next) {
        return next.handle(req).pipe(tap(() => {
        }, (err) => {
            if (err instanceof HttpErrorResponse) {
                if (err.status === 400) {
                    const errorObject = err.error;
                    if (errorObject.errors && errorObject.errors.children) {
                        const flattedErrors = this.flatten(errorObject.errors);
                        const get = (p, o) => p.reduce((xs, x) => (xs && xs[x]) ? xs[x] : null, o);
                        Object.keys(flattedErrors).forEach(propertyPath => {
                            /**
                             * Remove .i from path
                             */
                            const splitted = propertyPath.split('.');
                            splitted.pop();
                            const pp = splitted.filter(_ => {
                                return _ !== 'errors' && _ !== 'children';
                            });
                            this.formErrorService.propertyError.next({ property_path: pp.join('.'), message: get(propertyPath.split('.'), errorObject.errors) });
                        });
                    }
                }
            }
        }));
    }
    /**
     * @param object
     * @param path
     * @param res
     */
    flatten(object, path = '', res = undefined) {
        if (!Array.isArray(res)) {
            res = [];
        }
        if (object !== null && typeof object === 'object') {
            if (Array.isArray(object)) {
                for (let i = 0; i < object.length; i++) {
                    this.flatten(object[i], path + '.' + i, res);
                }
            }
            else {
                const keys = Object.keys(object);
                for (let i = 0; i < keys.length; i++) {
                    const key = keys[i];
                    this.flatten(object[key], path ? path + '.' + key : key, res);
                }
            }
        }
        else {
            if (path) {
                res[path] = object;
            }
        }
        return res;
    }
}
FormErrorInterceptor.ɵfac = function FormErrorInterceptor_Factory(t) { return new (t || FormErrorInterceptor)(ɵngcc0.ɵɵinject(FormErrorService)); };
FormErrorInterceptor.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: FormErrorInterceptor, factory: FormErrorInterceptor.ɵfac });
FormErrorInterceptor.ctorParameters = () => [
    { type: FormErrorService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormErrorInterceptor, [{
        type: Injectable
    }], function () { return [{ type: FormErrorService }]; }, null); })();

class CheckboxComponent extends FormInputComponent {
    constructor(_options, formErrorService) {
        super(_options);
        this._options = _options;
        this.formErrorService = formErrorService;
        this.placeholder = '';
        this.disableErrors = false;
        this.disabled = false;
        this.onChange = new EventEmitter();
        this.isChecked = false;
        this.onTouchedCallback = noop;
        this.onChangeCallback = noop;
    }
    get value() {
        return this.isChecked;
    }
    // set accessor including call the onchange callback
    set value(value) {
        this.isChecked = value;
    }
    writeValue(value) {
        if (value !== this.isChecked) {
            this.isChecked = value;
        }
    }
    onInputChange(isChecked) {
        this.value = isChecked;
        this.onChange.emit(this.isChecked);
        this.onChangeCallback(this.value);
    }
    // From ControlValueAccessor interface
    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }
    // From ControlValueAccessor interface
    registerOnTouched(fn) {
        this.onTouchedCallback = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
}
CheckboxComponent.ɵfac = function CheckboxComponent_Factory(t) { return new (t || CheckboxComponent)(ɵngcc0.ɵɵdirectiveInject('FormUtilitiesOptions'), ɵngcc0.ɵɵdirectiveInject(FormErrorService)); };
CheckboxComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CheckboxComponent, selectors: [["bd-checkbox"]], viewQuery: function CheckboxComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(CheckboxControlValueAccessor, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.input = _t.first);
    } }, inputs: { placeholder: "placeholder", disableErrors: "disableErrors", disabled: "disabled", isChecked: "isChecked", label: "label", inputClass: "inputClass", formControl: "formControl" }, outputs: { onChange: "onChange" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => CheckboxComponent),
                multi: true
            }]), ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c7, decls: 15, vars: 20, consts: [[1, "checkbox"], ["type", "checkbox", "ngDefaultControl", "", 3, "disabled", "ngModel", "ngModelChange", "change"], ["inputEl", ""], [4, "ngIf", "ngIfElse"], [3, "required", 4, "ngIf"], [3, "tips", 4, "ngIf"], [3, "errors", 4, "ngIf"], [3, "label", 4, "ngIf"], ["customLabel", ""], [3, "required"], [3, "tips"], [3, "errors"], [3, "label"]], template: function CheckboxComponent_Template(rf, ctx) { if (rf & 1) {
        const _r8 = ɵngcc0.ɵɵgetCurrentView();
        ɵngcc0.ɵɵprojectionDef(_c6);
        ɵngcc0.ɵɵelementStart(0, "div")(1, "div")(2, "div")(3, "div", 0)(4, "label")(5, "input", 1, 2);
        ɵngcc0.ɵɵlistener("ngModelChange", function CheckboxComponent_Template_input_ngModelChange_5_listener($event) { return ctx.isChecked = $event; })("change", function CheckboxComponent_Template_input_change_5_listener() { ɵngcc0.ɵɵrestoreView(_r8); const _r0 = ɵngcc0.ɵɵreference(6); return ctx.onInputChange(_r0.checked); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, CheckboxComponent_span_7_Template, 2, 1, "span", 3);
        ɵngcc0.ɵɵtemplate(8, CheckboxComponent_bd_form_required_8_Template, 1, 1, "bd-form-required", 4);
        ɵngcc0.ɵɵtemplate(9, CheckboxComponent_bd_form_tips_9_Template, 1, 1, "bd-form-tips", 5);
        ɵngcc0.ɵɵprojection(10);
        ɵngcc0.ɵɵelementEnd()()()();
        ɵngcc0.ɵɵtemplate(11, CheckboxComponent_bd_form_errors_11_Template, 1, 1, "bd-form-errors", 6);
        ɵngcc0.ɵɵtemplate(12, CheckboxComponent_bd_form_help_12_Template, 1, 1, "bd-form-help", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(13, CheckboxComponent_ng_template_13_Template, 1, 0, "ng-template", null, 8, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r6 = ɵngcc0.ɵɵreference(14);
        ɵngcc0.ɵɵclassMap(ctx.options.classFormGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap(ctx.options.classFromInput);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap(ctx.inputGroupClass);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassMap(ctx.options.classFormLabel);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("disabled", ctx.disabled)("ngModel", ctx.isChecked);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.label)("ngIfElse", _r6);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.requiredMarker);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.tips);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.errors);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.help);
    } }, directives: function () { return [ɵngcc2.CheckboxControlValueAccessor, ɵngcc2.DefaultValueAccessor, ɵngcc2.NgControlStatus, ɵngcc2.NgModel, ɵngcc1.NgIf, FormRequiredComponent, FormTipsComponent, FormErrorsComponent, FormHelpComponent]; }, encapsulation: 2 });
CheckboxComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: ['FormUtilitiesOptions',] }] },
    { type: FormErrorService }
];
CheckboxComponent.propDecorators = {
    input: [{ type: ViewChild, args: [CheckboxControlValueAccessor, { static: true },] }],
    label: [{ type: Input }],
    placeholder: [{ type: Input }],
    inputClass: [{ type: Input }],
    disableErrors: [{ type: Input }],
    disabled: [{ type: Input }],
    formControl: [{ type: Input }],
    onChange: [{ type: Output }],
    isChecked: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CheckboxComponent, [{
        type: Component,
        args: [{
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => CheckboxComponent),
                        multi: true
                    }],
                selector: 'bd-checkbox',
                template: "<div class=\"{{ options.classFormGroup }}\">\n  <div class=\"{{ options.classFromInput }}\">\n    <div class=\"{{ inputGroupClass }}\">\n      <div class=\"checkbox\">\n        <label class=\"{{ options.classFormLabel }}\">\n          <input\n            [disabled]=\"disabled\"\n            type=\"checkbox\"\n            [(ngModel)]=\"isChecked\"\n            #inputEl\n            (change)=\"onInputChange(inputEl.checked)\"\n            ngDefaultControl\n          />\n          <span *ngIf=\"label; else customLabel\">{{ label }}</span>\n          <bd-form-required [required]=\"requiredMarker\" *ngIf=\"requiredMarker\"></bd-form-required>\n          <bd-form-tips [tips]=\"tips\" *ngIf=\"tips\"></bd-form-tips>\n          <ng-content select=\"[section=after-input]\"></ng-content>\n        </label>\n      </div>\n    </div>\n  </div>\n  <bd-form-errors [errors]=\"errors\" *ngIf=\"errors\"></bd-form-errors>\n  <bd-form-help [label]=\"help\" *ngIf=\"help\"></bd-form-help>\n</div>\n\n<ng-template #customLabel>\n  <ng-content select=\"[section=custom-label]\"></ng-content>\n</ng-template>\n"
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: ['FormUtilitiesOptions']
            }] }, { type: FormErrorService }]; }, { placeholder: [{
            type: Input
        }], disableErrors: [{
            type: Input
        }], disabled: [{
            type: Input
        }], onChange: [{
            type: Output
        }], isChecked: [{
            type: Input
        }], input: [{
            type: ViewChild,
            args: [CheckboxControlValueAccessor, { static: true }]
        }], label: [{
            type: Input
        }], inputClass: [{
            type: Input
        }], formControl: [{
            type: Input
        }] }); })();

class DatetimepickerComponent extends FormInputComponent {
    constructor(_options, formErrorService, langService) {
        super(_options);
        this._options = _options;
        this.formErrorService = formErrorService;
        this.langService = langService;
        this.triggers = 'click';
        this.placeholder = '';
        this.disableErrors = false;
        this.bsConfig = new BsDatepickerConfig();
        this.bsLang = 'en';
        this.bsMaxDate = null;
        this.bsMinDate = null;
        this.isMeridian = false;
        this.showSpinners = false;
        this.readOnly = false;
    }
    writeValue(value) {
        if (!value) {
            this.dateTime = { date: null, time: new Date() };
        }
        else {
            this.dateTime = { date: new Date(value), time: new Date(value) };
        }
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.isDisabled = isDisabled;
    }
    onDateChange(date) {
        this.onChange(this.dateTime.date.toISOString());
    }
    onTimeChange(date) {
        if (this.dateTime.date) {
            this.dateTime.date.setHours(this.dateTime.time.getHours());
            this.dateTime.date.setMinutes(this.dateTime.time.getMinutes());
            this.dateTime.date.setSeconds(this.dateTime.time.getSeconds());
            this.onChange(this.dateTime.date.toISOString());
        }
    }
    ngOnInit() {
        super.ngOnInit();
        this.langService.use(this.bsLang);
        if (this.disabled) {
            this.formControl.disable();
        }
    }
}
DatetimepickerComponent.ɵfac = function DatetimepickerComponent_Factory(t) { return new (t || DatetimepickerComponent)(ɵngcc0.ɵɵdirectiveInject('FormUtilitiesOptions'), ɵngcc0.ɵɵdirectiveInject(FormErrorService), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.BsLocaleService)); };
DatetimepickerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DatetimepickerComponent, selectors: [["bd-datetimepicker"]], viewQuery: function DatetimepickerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(DatePickerComponent, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dp = _t.first);
    } }, inputs: { triggers: "triggers", placeholder: "placeholder", disableErrors: "disableErrors", bsConfig: "bsConfig", bsLang: "bsLang", bsMaxDate: "bsMaxDate", bsMinDate: "bsMinDate", isMeridian: "isMeridian", showSpinners: "showSpinners", readOnly: "readOnly", label: "label", help: "help", inputClass: "inputClass", formControl: "formControl" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DatetimepickerComponent),
                multi: true
            }]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 11, vars: 29, consts: [[3, "ngClass"], [3, "label"], [4, "ngIf"], [1, "row"], [1, "col-md-6", "col-sm-12"], ["type", "text", "bsDatepicker", "", 3, "bsConfig", "placeholder", "minDate", "maxDate", "triggers", "bsValue", "isDisabled", "readonly", "ngModel", "ngModelChange"], ["dp", ""], [3, "ngModel", "showMeridian", "disabled", "readonlyInput", "showSpinners", "ngModelChange"], [3, "errors"]], template: function DatetimepickerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "bd-form-label", 1);
        ɵngcc0.ɵɵtemplate(2, DatetimepickerComponent_bd_form_readonly_label_2_Template, 1, 0, "bd-form-readonly-label", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3)(4, "div", 4)(5, "input", 5, 6);
        ɵngcc0.ɵɵlistener("ngModelChange", function DatetimepickerComponent_Template_input_ngModelChange_5_listener($event) { return ctx.dateTime.date = $event; })("ngModelChange", function DatetimepickerComponent_Template_input_ngModelChange_5_listener($event) { return ctx.onDateChange($event); });
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(7, "div", 4)(8, "timepicker", 7);
        ɵngcc0.ɵɵlistener("ngModelChange", function DatetimepickerComponent_Template_timepicker_ngModelChange_8_listener($event) { return ctx.dateTime.time = $event; })("ngModelChange", function DatetimepickerComponent_Template_timepicker_ngModelChange_8_listener($event) { return ctx.onTimeChange($event); });
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelement(9, "bd-form-errors", 8)(10, "bd-form-help", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.options.classFormGroup);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(27, _c3, ctx.errors.length));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("label", ctx.label);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.readOnly);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵclassMapInterpolate2("", ctx.options.classFormControl, " ", ctx.inputClass, "");
        ɵngcc0.ɵɵproperty("bsConfig", ctx.bsConfig)("placeholder", ctx.placeholder)("minDate", ctx.bsMinDate)("maxDate", ctx.bsMaxDate)("triggers", ctx.triggers)("bsValue", ctx.dateTime.date)("isDisabled", ctx.disabled)("readonly", ctx.disabled)("ngModel", ctx.dateTime.date)("readonly", ctx.readOnly);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngModel", ctx.dateTime.time)("showMeridian", ctx.isMeridian)("disabled", ctx.disabled)("readonlyInput", ctx.isDisabled || ctx.readOnly)("showSpinners", ctx.showSpinners);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("errors", ctx.errors);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("label", ctx.help);
    } }, directives: function () { return [ɵngcc1.NgClass, FormLabelComponent, ɵngcc1.NgIf, FormReadonlyLabelComponent, ɵngcc3.BsDatepickerInputDirective, ɵngcc2.DefaultValueAccessor, ɵngcc3.BsDatepickerDirective, ɵngcc2.NgControlStatus, ɵngcc2.NgModel, ɵngcc4.TimepickerComponent, FormErrorsComponent, FormHelpComponent]; }, encapsulation: 2 });
DatetimepickerComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: ['FormUtilitiesOptions',] }] },
    { type: FormErrorService },
    { type: BsLocaleService }
];
DatetimepickerComponent.propDecorators = {
    dp: [{ type: ViewChild, args: [DatePickerComponent, { static: true },] }],
    label: [{ type: Input }],
    triggers: [{ type: Input }],
    help: [{ type: Input }],
    inputClass: [{ type: Input }],
    placeholder: [{ type: Input }],
    disableErrors: [{ type: Input }],
    formControl: [{ type: Input }],
    bsConfig: [{ type: Input }],
    bsLang: [{ type: Input }],
    bsMaxDate: [{ type: Input }],
    bsMinDate: [{ type: Input }],
    isMeridian: [{ type: Input }],
    showSpinners: [{ type: Input }],
    readOnly: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DatetimepickerComponent, [{
        type: Component,
        args: [{
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DatetimepickerComponent),
                        multi: true
                    }],
                selector: 'bd-datetimepicker',
                template: "<div class=\"{{ options.classFormGroup }}\" [ngClass]=\"{'has-errors': errors.length}\">\n  <bd-form-label [label]=\"label\"></bd-form-label>\n  <bd-form-readonly-label *ngIf=\"readOnly\"></bd-form-readonly-label>\n  <div class=\"row\">\n    <div class=\"col-md-6 col-sm-12\">\n      <input #dp\n             type=\"text\"\n             class=\"{{ options.classFormControl }} {{ inputClass }}\"\n             bsDatepicker\n             [bsConfig]=\"bsConfig\"\n             [placeholder]=\"placeholder\"\n             [minDate]=\"bsMinDate\"\n             [maxDate]=\"bsMaxDate\"\n             [triggers]=\"triggers\"\n             [bsValue]=\"dateTime.date\"\n             [isDisabled]=\"disabled\"\n             [readonly]=\"disabled\"\n             [(ngModel)]=\"dateTime.date\"\n             [readonly]=\"readOnly\"\n             (ngModelChange)=\"onDateChange($event)\"\n      />\n    </div>\n    <div class=\"col-md-6 col-sm-12\">\n      <timepicker\n        [(ngModel)]=\"dateTime.time\"\n        (ngModelChange)=\"onTimeChange($event)\"\n        [showMeridian]=\"isMeridian\"\n        [disabled]=\"disabled\"\n        [readonlyInput]=\"isDisabled || readOnly\"\n        [showSpinners]=\"showSpinners\"\n      ></timepicker>\n    </div>\n  </div>\n\n  <bd-form-errors [errors]=\"errors\"></bd-form-errors>\n  <bd-form-help [label]=\"help\"></bd-form-help>\n\n</div>\n"
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: ['FormUtilitiesOptions']
            }] }, { type: FormErrorService }, { type: ɵngcc3.BsLocaleService }]; }, { triggers: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], disableErrors: [{
            type: Input
        }], bsConfig: [{
            type: Input
        }], bsLang: [{
            type: Input
        }], bsMaxDate: [{
            type: Input
        }], bsMinDate: [{
            type: Input
        }], isMeridian: [{
            type: Input
        }], showSpinners: [{
            type: Input
        }], readOnly: [{
            type: Input
        }], dp: [{
            type: ViewChild,
            args: [DatePickerComponent, { static: true }]
        }], label: [{
            type: Input
        }], help: [{
            type: Input
        }], inputClass: [{
            type: Input
        }], formControl: [{
            type: Input
        }] }); })();

class FormLabelComponent {
    constructor(_options) {
        this._options = _options;
    }
    get options() {
        return this._options;
    }
}
FormLabelComponent.ɵfac = function FormLabelComponent_Factory(t) { return new (t || FormLabelComponent)(ɵngcc0.ɵɵdirectiveInject('FormUtilitiesOptions')); };
FormLabelComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FormLabelComponent, selectors: [["bd-form-label"]], inputs: { label: "label", inputId: "inputId" }, decls: 1, vars: 1, consts: [[3, "class", "for", 4, "ngIf"], [3, "for"]], template: function FormLabelComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, FormLabelComponent_label_0_Template, 2, 5, "label", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.label);
    } }, directives: [ɵngcc1.NgIf], encapsulation: 2 });
FormLabelComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: ['FormUtilitiesOptions',] }] }
];
FormLabelComponent.propDecorators = {
    label: [{ type: Input }],
    inputId: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormLabelComponent, [{
        type: Component,
        args: [{
                selector: 'bd-form-label',
                template: "<label class=\"{{ options.classFormLabel }}\" for=\"{{ inputId }}\" *ngIf=\"label\">{{ label }}</label>\n"
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: ['FormUtilitiesOptions']
            }] }]; }, { label: [{
            type: Input
        }], inputId: [{
            type: Input
        }] }); })();

class FormErrorsComponent {
    constructor(_options) {
        this._options = _options;
    }
    get options() {
        return this._options;
    }
}
FormErrorsComponent.ɵfac = function FormErrorsComponent_Factory(t) { return new (t || FormErrorsComponent)(ɵngcc0.ɵɵdirectiveInject('FormUtilitiesOptions')); };
FormErrorsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FormErrorsComponent, selectors: [["bd-form-errors"]], inputs: { errors: "errors" }, decls: 1, vars: 1, consts: [[3, "class", 4, "ngIf"], [4, "ngFor", "ngForOf"]], template: function FormErrorsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, FormErrorsComponent_ul_0_Template, 2, 4, "ul", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.errors.length);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgForOf], pipes: [ɵngcc5.TranslatePipe], encapsulation: 2 });
FormErrorsComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: ['FormUtilitiesOptions',] }] }
];
FormErrorsComponent.propDecorators = {
    errors: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormErrorsComponent, [{
        type: Component,
        args: [{
                selector: 'bd-form-errors',
                template: "<ul class=\"{{ options.classFormError }}\" *ngIf=\"errors.length\">\n  <li *ngFor=\"let error of errors\">\n    {{ error | translate }}\n  </li>\n</ul>"
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: ['FormUtilitiesOptions']
            }] }]; }, { errors: [{
            type: Input
        }] }); })();

class FormHelpComponent {
    constructor(_options) {
        this._options = _options;
    }
    get options() {
        return this._options;
    }
}
FormHelpComponent.ɵfac = function FormHelpComponent_Factory(t) { return new (t || FormHelpComponent)(ɵngcc0.ɵɵdirectiveInject('FormUtilitiesOptions')); };
FormHelpComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FormHelpComponent, selectors: [["bd-form-help"]], inputs: { label: "label" }, decls: 1, vars: 1, consts: [[3, "class", 4, "ngIf"]], template: function FormHelpComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, FormHelpComponent_div_0_Template, 3, 6, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.label);
    } }, directives: [ɵngcc1.NgIf], pipes: [ɵngcc5.TranslatePipe], encapsulation: 2 });
FormHelpComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: ['FormUtilitiesOptions',] }] }
];
FormHelpComponent.propDecorators = {
    label: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormHelpComponent, [{
        type: Component,
        args: [{
                selector: 'bd-form-help',
                template: "<div class=\"{{ options.classFormHelp }}\" *ngIf=\"label\">\n  {{ label | translate }}\n</div>\n"
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: ['FormUtilitiesOptions']
            }] }]; }, { label: [{
            type: Input
        }] }); })();

class RteComponent extends FormInputComponent {
    constructor(_options, formErrorService) {
        super(_options);
        this._options = _options;
        this.formErrorService = formErrorService;
        this.rteConfig = {
            toolbar: [
                [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                ['bold', 'italic', 'underline', 'strike'],
                ['blockquote', 'code-block'],
                [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                [{ 'align': [] }],
                ['clean'],
                ['link']
            ]
        };
        this.placeholder = '';
        this.disableErrors = false;
        this.readOnly = false;
    }
    writeValue(writeValue) {
    }
    registerOnChange(fn) {
    }
    registerOnTouched(fn) {
    }
    setDisabledState(isDisabled) {
    }
}
RteComponent.ɵfac = function RteComponent_Factory(t) { return new (t || RteComponent)(ɵngcc0.ɵɵdirectiveInject('FormUtilitiesOptions'), ɵngcc0.ɵɵdirectiveInject(FormErrorService)); };
RteComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: RteComponent, selectors: [["bd-rte"]], viewQuery: function RteComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(DefaultValueAccessor, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.input = _t.first);
    } }, inputs: { rteConfig: "rteConfig", placeholder: "placeholder", disableErrors: "disableErrors", readOnly: "readOnly", label: "label", help: "help", inputClass: "inputClass", formControl: "formControl" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => RteComponent),
                multi: true
            }]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 14, vars: 27, consts: [[3, "ngClass"], [3, "label", "inputId"], [3, "required", 4, "ngIf"], [3, "tips", 4, "ngIf"], [3, "maxLength", "form", 4, "ngIf"], [4, "ngIf"], [3, "readOnly", "formControl", "modules"], ["editor", ""], [3, "errors", 4, "ngIf"], [3, "label", 4, "ngIf"], [3, "required"], [3, "tips"], [3, "maxLength", "form"], [3, "errors"], [3, "label"]], template: function RteComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div")(2, "div");
        ɵngcc0.ɵɵelement(3, "bd-form-label", 1);
        ɵngcc0.ɵɵtemplate(4, RteComponent_bd_form_required_4_Template, 1, 1, "bd-form-required", 2);
        ɵngcc0.ɵɵtemplate(5, RteComponent_bd_form_tips_5_Template, 1, 1, "bd-form-tips", 3);
        ɵngcc0.ɵɵtemplate(6, RteComponent_bd_form_counter_6_Template, 1, 2, "bd-form-counter", 4);
        ɵngcc0.ɵɵtemplate(7, RteComponent_bd_form_readonly_label_7_Template, 1, 0, "bd-form-readonly-label", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div");
        ɵngcc0.ɵɵelement(9, "quill-editor", 6, 7);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵtemplate(11, RteComponent_bd_form_errors_11_Template, 1, 1, "bd-form-errors", 8);
        ɵngcc0.ɵɵtemplate(12, RteComponent_bd_form_counter_12_Template, 1, 2, "bd-form-counter", 4);
        ɵngcc0.ɵɵtemplate(13, RteComponent_bd_form_help_13_Template, 1, 1, "bd-form-help", 9);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.options.classFormGroup);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(25, _c3, ctx.errors.length));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap(ctx.options.classFromInput);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap(ctx.options.classFromLegend);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("label", ctx.label)("inputId", ctx.uniqueId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.requiredMarker);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.tips);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.maxLength && ctx.options.counterBefore);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.readOnly);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap(ctx.inputGroupClass);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("readOnly", ctx.readOnly)("formControl", ctx.formControl)("modules", ctx.rteConfig);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.errors);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.maxLength && !ctx.options.counterBefore);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.help);
    } }, directives: function () { return [ɵngcc1.NgClass, FormLabelComponent, ɵngcc1.NgIf, FormRequiredComponent, FormTipsComponent, FormCounterComponent, FormReadonlyLabelComponent, ɵngcc6.QuillEditorComponent, ɵngcc2.NgControlStatus, ɵngcc2.FormControlDirective, FormErrorsComponent, FormHelpComponent]; }, encapsulation: 2 });
RteComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: ['FormUtilitiesOptions',] }] },
    { type: FormErrorService }
];
RteComponent.propDecorators = {
    input: [{ type: ViewChild, args: [DefaultValueAccessor, { static: true },] }],
    rteConfig: [{ type: Input }],
    label: [{ type: Input }],
    help: [{ type: Input }],
    inputClass: [{ type: Input }],
    placeholder: [{ type: Input }],
    disableErrors: [{ type: Input }],
    formControl: [{ type: Input }],
    readOnly: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RteComponent, [{
        type: Component,
        args: [{
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => RteComponent),
                        multi: true
                    }],
                selector: 'bd-rte',
                template: "<div class=\"{{ options.classFormGroup }}\" [ngClass]=\"{'has-errors': errors.length}\">\n\n  <div class=\"{{ options.classFromInput }}\">\n\n    <div class=\"{{ options.classFromLegend }}\">\n\n      <bd-form-label [label]=\"label\" [inputId]=\"uniqueId\"></bd-form-label>\n      <bd-form-required [required]=\"requiredMarker\" *ngIf=\"requiredMarker\"></bd-form-required>\n      <bd-form-tips [tips]=\"tips\" *ngIf=\"tips\"></bd-form-tips>\n      <bd-form-counter [maxLength]=\"maxLength\" [form]=\"formControl\" *ngIf=\"maxLength && options.counterBefore\"></bd-form-counter>\n      <bd-form-readonly-label *ngIf=\"readOnly\"></bd-form-readonly-label>\n    </div>\n\n    <div class=\"{{ inputGroupClass }}\">\n\n      <quill-editor #editor [readOnly]=\"readOnly\" [formControl]=\"formControl\"  [modules]=\"rteConfig\"></quill-editor>\n\n    </div>\n  </div>\n\n  <bd-form-errors [errors]=\"errors\" *ngIf=\"errors\"></bd-form-errors>\n  <bd-form-counter [maxLength]=\"maxLength\" [form]=\"formControl\" *ngIf=\"maxLength && !options.counterBefore\"></bd-form-counter>\n  <bd-form-help [label]=\"help\" *ngIf=\"help\"></bd-form-help>\n</div>\n"
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: ['FormUtilitiesOptions']
            }] }, { type: FormErrorService }]; }, { rteConfig: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], disableErrors: [{
            type: Input
        }], readOnly: [{
            type: Input
        }], input: [{
            type: ViewChild,
            args: [DefaultValueAccessor, { static: true }]
        }], label: [{
            type: Input
        }], help: [{
            type: Input
        }], inputClass: [{
            type: Input
        }], formControl: [{
            type: Input
        }] }); })();

class FormTipsComponent {
    constructor(_options) {
        this._options = _options;
    }
    get options() {
        return this._options;
    }
}
FormTipsComponent.ɵfac = function FormTipsComponent_Factory(t) { return new (t || FormTipsComponent)(ɵngcc0.ɵɵdirectiveInject('FormUtilitiesOptions')); };
FormTipsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FormTipsComponent, selectors: [["bd-form-tips"]], inputs: { tips: "tips" }, decls: 1, vars: 1, consts: [[4, "ngIf"], [4, "ngFor", "ngForOf"], [3, "popover"]], template: function FormTipsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, FormTipsComponent_ng_container_0_Template, 2, 1, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.tips && ctx.tips.length);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgForOf, ɵngcc7.PopoverDirective], pipes: [ɵngcc5.TranslatePipe], encapsulation: 2 });
FormTipsComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: ['FormUtilitiesOptions',] }] }
];
FormTipsComponent.propDecorators = {
    tips: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormTipsComponent, [{
        type: Component,
        args: [{
                selector: 'bd-form-tips',
                template: "<ng-container *ngIf=\"tips && tips.length\">\n  <span *ngFor=\"let tip of tips\">\n    <i class=\"fas {{ tip.icon }}\" popover=\"{{ tip.tooltip|translate }}\"></i>\n  </span>\n</ng-container>\n"
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: ['FormUtilitiesOptions']
            }] }]; }, { tips: [{
            type: Input
        }] }); })();

class FormRequiredComponent {
    constructor(_options, _sanitizer) {
        this._options = _options;
        this._sanitizer = _sanitizer;
    }
    get options() {
        return this._options;
    }
    get requiredString() {
        return this._sanitizer.bypassSecurityTrustHtml(this.options.requiredString);
    }
}
FormRequiredComponent.ɵfac = function FormRequiredComponent_Factory(t) { return new (t || FormRequiredComponent)(ɵngcc0.ɵɵdirectiveInject('FormUtilitiesOptions'), ɵngcc0.ɵɵdirectiveInject(ɵngcc8.DomSanitizer)); };
FormRequiredComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FormRequiredComponent, selectors: [["bd-form-required"]], inputs: { required: "required" }, decls: 1, vars: 1, consts: [[3, "class", "innerHTML", 4, "ngIf"], [3, "innerHTML"]], template: function FormRequiredComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, FormRequiredComponent_span_0_Template, 1, 4, "span", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.required);
    } }, directives: [ɵngcc1.NgIf], encapsulation: 2 });
FormRequiredComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: ['FormUtilitiesOptions',] }] },
    { type: DomSanitizer }
];
FormRequiredComponent.propDecorators = {
    required: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormRequiredComponent, [{
        type: Component,
        args: [{
                selector: 'bd-form-required',
                template: "<span class=\"{{ options.classFormRequired }}\" *ngIf=\"required\" [innerHTML]=\"requiredString\"></span>\n"
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: ['FormUtilitiesOptions']
            }] }, { type: ɵngcc8.DomSanitizer }]; }, { required: [{
            type: Input
        }] }); })();

class MaxLengthDirective {
    constructor(_options, renderer, elementRef) {
        this._options = _options;
        this.renderer = renderer;
        this.elementRef = elementRef;
    }
    ngAfterViewInit() {
        this.counter();
    }
    counter() {
        const counterDiv = this.renderer.createElement('div');
        this.renderer.addClass(counterDiv, this._options.classFormGroup);
        this.renderer.insertBefore(this.elementRef.nativeElement.parentNode, counterDiv, this.elementRef.nativeElement);
        this.renderer.appendChild(counterDiv, this.elementRef.nativeElement);
    }
}
MaxLengthDirective.ɵfac = function MaxLengthDirective_Factory(t) { return new (t || MaxLengthDirective)(ɵngcc0.ɵɵdirectiveInject('FormUtilitiesOptions'), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
MaxLengthDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: MaxLengthDirective, selectors: [["", "bd-maxlength", ""]], hostBindings: function MaxLengthDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("input", function MaxLengthDirective_input_HostBindingHandler() { return ctx.counter(); })("load", function MaxLengthDirective_load_HostBindingHandler() { return ctx.counter(); });
    } } });
MaxLengthDirective.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: ['FormUtilitiesOptions',] }] },
    { type: Renderer2 },
    { type: ElementRef }
];
MaxLengthDirective.propDecorators = {
    counter: [{ type: HostListener, args: ['input',] }, { type: HostListener, args: ['load',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MaxLengthDirective, [{
        type: Directive,
        args: [{
                selector: '[bd-maxlength]'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: ['FormUtilitiesOptions']
            }] }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { counter: [{
            type: HostListener,
            args: ['input']
        }, {
            type: HostListener,
            args: ['load']
        }] }); })();

class FormCounterComponent {
    constructor(_options) {
        this._options = _options;
    }
    get options() {
        return this._options;
    }
    getMaxLengthLabel() {
        let value = this.form.value;
        if (value === null || value === 'undefined') {
            value = '';
        }
        const length = this.maxLength - String(value).length;
        return this._options.maxLengthString.replace('%s', length.toString());
    }
}
FormCounterComponent.ɵfac = function FormCounterComponent_Factory(t) { return new (t || FormCounterComponent)(ɵngcc0.ɵɵdirectiveInject('FormUtilitiesOptions')); };
FormCounterComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FormCounterComponent, selectors: [["bd-form-counter"]], inputs: { maxLength: "maxLength", form: "form" }, decls: 2, vars: 4, template: function FormCounterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "span");
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.options.classFormCounter);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.getMaxLengthLabel(), "\n");
    } }, encapsulation: 2 });
FormCounterComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: ['FormUtilitiesOptions',] }] }
];
FormCounterComponent.propDecorators = {
    maxLength: [{ type: Input }],
    form: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormCounterComponent, [{
        type: Component,
        args: [{
                selector: 'bd-form-counter',
                template: "<span class=\"{{ options.classFormCounter }}\">\n  {{ getMaxLengthLabel() }}\n</span>\n"
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: ['FormUtilitiesOptions']
            }] }]; }, { maxLength: [{
            type: Input
        }], form: [{
            type: Input
        }] }); })();

class FormAddonComponent {
    constructor(_options, _sanitizer) {
        this._options = _options;
        this._sanitizer = _sanitizer;
    }
    get hostClasses() {
        return this.position === 'prepend' ? this.options.classFormInputGroupPrepend : this.options.classFormInputGroupAppend;
    }
    get options() {
        return this._options;
    }
    get addonString() {
        return this._sanitizer.bypassSecurityTrustHtml(this.text);
    }
}
FormAddonComponent.ɵfac = function FormAddonComponent_Factory(t) { return new (t || FormAddonComponent)(ɵngcc0.ɵɵdirectiveInject('FormUtilitiesOptions'), ɵngcc0.ɵɵdirectiveInject(ɵngcc8.DomSanitizer)); };
FormAddonComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FormAddonComponent, selectors: [["bd-form-addon"]], hostVars: 2, hostBindings: function FormAddonComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.hostClasses);
    } }, inputs: { text: "text", position: "position" }, decls: 1, vars: 4, consts: [[3, "innerHTML"]], template: function FormAddonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "span", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.options.classFormInputGroupText);
        ɵngcc0.ɵɵproperty("innerHTML", ctx.addonString, ɵngcc0.ɵɵsanitizeHtml);
    } }, encapsulation: 2 });
FormAddonComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: ['FormUtilitiesOptions',] }] },
    { type: DomSanitizer }
];
FormAddonComponent.propDecorators = {
    text: [{ type: Input }],
    position: [{ type: Input }],
    hostClasses: [{ type: HostBinding, args: ['class',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormAddonComponent, [{
        type: Component,
        args: [{
                selector: 'bd-form-addon',
                template: "<span class=\"{{ options.classFormInputGroupText }}\" [innerHTML]=\"addonString\"></span>\n"
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: ['FormUtilitiesOptions']
            }] }, { type: ɵngcc8.DomSanitizer }]; }, { hostClasses: [{
            type: HostBinding,
            args: ['class']
        }], text: [{
            type: Input
        }], position: [{
            type: Input
        }] }); })();

class TimepickerComponent extends FormInputComponent {
    constructor(_options, formErrorService, langService) {
        super(_options);
        this._options = _options;
        this.formErrorService = formErrorService;
        this.langService = langService;
        this.placeholder = '';
        this.disableErrors = false;
        this.bsConfig = new BsDatepickerConfig();
        this.isMeridian = false;
        this.readOnly = false;
    }
    writeValue(value) {
        if (!value) {
            this.dateTime = { date: null, time: new Date() };
        }
        else {
            this.dateTime = { date: new Date(value), time: new Date(value) };
        }
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.isDisabled = isDisabled;
    }
    onDateChange(date) {
        this.onChange(this.dateTime.date.toISOString());
    }
    onTimeChange(date) {
        if (this.dateTime.date) {
            this.dateTime.date.setHours(this.dateTime.time.getHours());
            this.dateTime.date.setMinutes(this.dateTime.time.getMinutes());
            this.dateTime.date.setSeconds(this.dateTime.time.getSeconds());
            this.onChange(this.dateTime.date.toISOString());
        }
    }
    ngOnInit() {
        super.ngOnInit();
        if (this.disabled) {
            this.formControl.disable();
        }
    }
}
TimepickerComponent.ɵfac = function TimepickerComponent_Factory(t) { return new (t || TimepickerComponent)(ɵngcc0.ɵɵdirectiveInject('FormUtilitiesOptions'), ɵngcc0.ɵɵdirectiveInject(FormErrorService), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.BsLocaleService)); };
TimepickerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TimepickerComponent, selectors: [["bd-timepicker"]], viewQuery: function TimepickerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(DatePickerComponent, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dp = _t.first);
    } }, inputs: { placeholder: "placeholder", disableErrors: "disableErrors", bsConfig: "bsConfig", isMeridian: "isMeridian", readOnly: "readOnly", label: "label", help: "help", inputClass: "inputClass", formControl: "formControl" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => TimepickerComponent),
                multi: true
            }]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 13, vars: 28, consts: [[3, "ngClass"], [3, "label", "inputId"], [3, "required", 4, "ngIf"], [3, "tips", 4, "ngIf"], [4, "ngIf"], ["position", "prepend", 3, "text", 4, "ngIf"], [3, "readonlyInput", "disabled", "formControl", "showMeridian"], ["position", "append", 3, "text", 4, "ngIf"], [3, "errors", 4, "ngIf"], [3, "label", 4, "ngIf"], [3, "required"], [3, "tips"], ["position", "prepend", 3, "text"], ["position", "append", 3, "text"], [3, "errors"], [3, "label"]], template: function TimepickerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div")(2, "div");
        ɵngcc0.ɵɵelement(3, "bd-form-label", 1);
        ɵngcc0.ɵɵtemplate(4, TimepickerComponent_bd_form_required_4_Template, 1, 1, "bd-form-required", 2);
        ɵngcc0.ɵɵtemplate(5, TimepickerComponent_bd_form_tips_5_Template, 1, 1, "bd-form-tips", 3);
        ɵngcc0.ɵɵtemplate(6, TimepickerComponent_bd_form_readonly_label_6_Template, 1, 0, "bd-form-readonly-label", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div");
        ɵngcc0.ɵɵtemplate(8, TimepickerComponent_bd_form_addon_8_Template, 1, 1, "bd-form-addon", 5);
        ɵngcc0.ɵɵelement(9, "timepicker", 6);
        ɵngcc0.ɵɵtemplate(10, TimepickerComponent_bd_form_addon_10_Template, 1, 1, "bd-form-addon", 7);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵtemplate(11, TimepickerComponent_bd_form_errors_11_Template, 1, 1, "bd-form-errors", 8);
        ɵngcc0.ɵɵtemplate(12, TimepickerComponent_bd_form_help_12_Template, 1, 1, "bd-form-help", 9);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.options.classFormGroup);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(26, _c3, ctx.errors.length));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap(ctx.options.classFromInput);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap(ctx.options.classFromLegend);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("label", ctx.label)("inputId", ctx.uniqueId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.requiredMarker);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.tips);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.readOnly);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap(ctx.inputGroupClass);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.prepend);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("readonlyInput", ctx.readOnly)("disabled", ctx.disabled)("formControl", ctx.formControl)("showMeridian", ctx.isMeridian);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.append);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.errors);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.help);
    } }, directives: function () { return [ɵngcc1.NgClass, FormLabelComponent, ɵngcc1.NgIf, FormRequiredComponent, FormTipsComponent, FormReadonlyLabelComponent, FormAddonComponent, ɵngcc4.TimepickerComponent, ɵngcc2.NgControlStatus, ɵngcc2.FormControlDirective, FormErrorsComponent, FormHelpComponent]; }, encapsulation: 2 });
TimepickerComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: ['FormUtilitiesOptions',] }] },
    { type: FormErrorService },
    { type: BsLocaleService }
];
TimepickerComponent.propDecorators = {
    dp: [{ type: ViewChild, args: [DatePickerComponent, { static: true },] }],
    label: [{ type: Input }],
    help: [{ type: Input }],
    inputClass: [{ type: Input }],
    placeholder: [{ type: Input }],
    disableErrors: [{ type: Input }],
    formControl: [{ type: Input }],
    bsConfig: [{ type: Input }],
    isMeridian: [{ type: Input }],
    readOnly: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TimepickerComponent, [{
        type: Component,
        args: [{
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => TimepickerComponent),
                        multi: true
                    }],
                selector: 'bd-timepicker',
                template: "<div class=\"{{ options.classFormGroup }}\" [ngClass]=\"{'has-errors': errors.length}\">\n\n  <div class=\"{{ options.classFromInput }}\">\n\n    <div class=\"{{ options.classFromLegend }}\">\n\n      <bd-form-label [label]=\"label\" [inputId]=\"uniqueId\"></bd-form-label>\n      <bd-form-required [required]=\"requiredMarker\" *ngIf=\"requiredMarker\"></bd-form-required>\n      <bd-form-tips [tips]=\"tips\" *ngIf=\"tips\"></bd-form-tips>\n      <bd-form-readonly-label *ngIf=\"readOnly\"></bd-form-readonly-label>\n    </div>\n\n    <div class=\"{{ inputGroupClass }}\">\n\n      <bd-form-addon [text]=\"prepend\" position=\"prepend\" *ngIf=\"prepend\"></bd-form-addon>\n      <timepicker [readonlyInput]=\"readOnly\" [disabled]=\"disabled\" [formControl]=\"formControl\" [showMeridian]=\"isMeridian\"></timepicker>\n      <bd-form-addon [text]=\"append\" position=\"append\" *ngIf=\"append\"></bd-form-addon>\n\n    </div>\n  </div>\n\n  <bd-form-errors [errors]=\"errors\" *ngIf=\"errors\"></bd-form-errors>\n  <bd-form-help [label]=\"help\" *ngIf=\"help\"></bd-form-help>\n</div>\n"
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: ['FormUtilitiesOptions']
            }] }, { type: FormErrorService }, { type: ɵngcc3.BsLocaleService }]; }, { placeholder: [{
            type: Input
        }], disableErrors: [{
            type: Input
        }], bsConfig: [{
            type: Input
        }], isMeridian: [{
            type: Input
        }], readOnly: [{
            type: Input
        }], dp: [{
            type: ViewChild,
            args: [DatePickerComponent, { static: true }]
        }], label: [{
            type: Input
        }], help: [{
            type: Input
        }], inputClass: [{
            type: Input
        }], formControl: [{
            type: Input
        }] }); })();

class FormLabelIconComponent {
    constructor() {
        this.icon = null;
        this.font = 'far';
    }
}
FormLabelIconComponent.ɵfac = function FormLabelIconComponent_Factory(t) { return new (t || FormLabelIconComponent)(); };
FormLabelIconComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FormLabelIconComponent, selectors: [["bd-form-label-icon"]], inputs: { icon: "icon", font: "font" }, decls: 1, vars: 1, consts: [[3, "class", 4, "ngIf"]], template: function FormLabelIconComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, FormLabelIconComponent_i_0_Template, 1, 4, "i", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.icon);
    } }, directives: [ɵngcc1.NgIf], encapsulation: 2 });
FormLabelIconComponent.propDecorators = {
    icon: [{ type: Input, args: ['icon',] }],
    font: [{ type: Input, args: ['font',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormLabelIconComponent, [{
        type: Component,
        args: [{
                selector: 'bd-form-label-icon',
                template: "<i class=\"{{ font }} fa-{{ icon }}\" *ngIf=\"icon\"></i>\n"
            }]
    }], function () { return []; }, { icon: [{
            type: Input,
            args: ['icon']
        }], font: [{
            type: Input,
            args: ['font']
        }] }); })();

class RadioComponent extends FormInputComponent {
    constructor(_options, formErrorService) {
        super(_options);
        this._options = _options;
        this.formErrorService = formErrorService;
        this.disableErrors = false;
    }
    ngOnInit() {
        super.ngOnInit();
    }
}
RadioComponent.ɵfac = function RadioComponent_Factory(t) { return new (t || RadioComponent)(ɵngcc0.ɵɵdirectiveInject('FormUtilitiesOptions'), ɵngcc0.ɵɵdirectiveInject(FormErrorService)); };
RadioComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: RadioComponent, selectors: [["bd-radio"]], inputs: { disableErrors: "disableErrors", label: "label", inputClass: "inputClass", placeholder: "placeholder", fieldName: "fieldName", radioOptions: "radioOptions", formControl: "formControl", control: "control", group: "group" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c9, decls: 9, vars: 15, consts: [[3, "formGroup"], ["class", "checkbox", 4, "ngFor", "ngForOf"], [3, "required", 4, "ngIf"], [3, "tips", 4, "ngIf"], [3, "errors", 4, "ngIf"], [3, "label", 4, "ngIf"], [1, "checkbox"], ["type", "radio", 3, "value", "formControlName"], [3, "required"], [3, "tips"], [3, "errors"], [3, "label"]], template: function RadioComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c8);
        ɵngcc0.ɵɵelementStart(0, "div")(1, "div")(2, "div", 0);
        ɵngcc0.ɵɵtemplate(3, RadioComponent_div_3_Template, 5, 6, "div", 1);
        ɵngcc0.ɵɵtemplate(4, RadioComponent_bd_form_required_4_Template, 1, 1, "bd-form-required", 2);
        ɵngcc0.ɵɵtemplate(5, RadioComponent_bd_form_tips_5_Template, 1, 1, "bd-form-tips", 3);
        ɵngcc0.ɵɵprojection(6);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵtemplate(7, RadioComponent_bd_form_errors_7_Template, 1, 1, "bd-form-errors", 4);
        ɵngcc0.ɵɵtemplate(8, RadioComponent_bd_form_help_8_Template, 1, 1, "bd-form-help", 5);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.options.classFormGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap(ctx.options.classFromInput);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap(ctx.inputGroupClass);
        ɵngcc0.ɵɵproperty("formGroup", ctx.group);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.radioOptions);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.requiredMarker);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.tips);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.errors);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.help);
    } }, directives: [ɵngcc2.NgControlStatusGroup, ɵngcc2.FormGroupDirective, ɵngcc1.NgForOf, ɵngcc2.RadioControlValueAccessor, ɵngcc2.DefaultValueAccessor, ɵngcc2.NgControlStatus, ɵngcc2.FormControlName, ɵngcc1.NgIf, FormRequiredComponent, FormTipsComponent, FormErrorsComponent, FormHelpComponent], encapsulation: 2 });
RadioComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: ['FormUtilitiesOptions',] }] },
    { type: FormErrorService }
];
RadioComponent.propDecorators = {
    label: [{ type: Input }],
    inputClass: [{ type: Input }],
    disableErrors: [{ type: Input }],
    placeholder: [{ type: Input }],
    fieldName: [{ type: Input }],
    radioOptions: [{ type: Input }],
    formControl: [{ type: Input }],
    control: [{ type: Input }],
    group: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RadioComponent, [{
        type: Component,
        args: [{
                selector: 'bd-radio',
                template: "<div class=\"{{ options.classFormGroup }}\">\n  <div class=\"{{ options.classFromInput }}\">\n    <div class=\"{{ inputGroupClass }}\" [formGroup]=\"group\">\n      <div class=\"checkbox\" *ngFor=\"let option of radioOptions\">\n        <label class=\"{{ options.classFormLabel }}\">\n          <input\n            type=\"radio\"\n            [value]=\"option.value\"\n            formControlName=\"{{ fieldName }}\"\n          />\n          <span>{{ option.label }}</span>\n        </label>\n      </div>\n      <bd-form-required [required]=\"requiredMarker\" *ngIf=\"requiredMarker\"></bd-form-required>\n      <bd-form-tips [tips]=\"tips\" *ngIf=\"tips\"></bd-form-tips>\n      <ng-content select=\"[section=after-input]\"></ng-content>\n    </div>\n  </div>\n  <bd-form-errors [errors]=\"errors\" *ngIf=\"errors\"></bd-form-errors>\n  <bd-form-help [label]=\"help\" *ngIf=\"help\"></bd-form-help>\n</div>\n"
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: ['FormUtilitiesOptions']
            }] }, { type: FormErrorService }]; }, { disableErrors: [{
            type: Input
        }], label: [{
            type: Input
        }], inputClass: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], fieldName: [{
            type: Input
        }], radioOptions: [{
            type: Input
        }], formControl: [{
            type: Input
        }], control: [{
            type: Input
        }], group: [{
            type: Input
        }] }); })();

class FormReadonlyLabelComponent {
    constructor(options) {
        this.options = options;
    }
    ngOnInit() {
    }
}
FormReadonlyLabelComponent.ɵfac = function FormReadonlyLabelComponent_Factory(t) { return new (t || FormReadonlyLabelComponent)(ɵngcc0.ɵɵdirectiveInject('FormUtilitiesOptions')); };
FormReadonlyLabelComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FormReadonlyLabelComponent, selectors: [["bd-form-readonly-label"]], decls: 2, vars: 2, consts: [[3, "ngClass"]], template: function FormReadonlyLabelComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "span", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ctx.options.classFormReadonly);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.options.readonlyString);
    } }, directives: [ɵngcc1.NgClass], encapsulation: 2 });
FormReadonlyLabelComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: ['FormUtilitiesOptions',] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormReadonlyLabelComponent, [{
        type: Component,
        args: [{
                selector: 'bd-form-readonly-label',
                template: "<span [ngClass]=\"options.classFormReadonly\">{{ options.readonlyString }}</span>\n"
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: ['FormUtilitiesOptions']
            }] }]; }, null); })();

defineLocale('de', deLocale);
const DefaultFormUtilitiesOptions = {
    displayErrors: true,
    classFormGroup: 'form-group',
    classFromInput: 'form-input',
    classFormInputGroup: 'input-group',
    classFormInputGroupPrepend: 'input-group-prepend',
    classFormInputGroupAppend: 'input-group-append',
    classFormInputGroupText: 'input-group-text',
    classFromLegend: 'form-legend',
    classFormLabel: 'form-label',
    classFormReadonly: 'form-readonly',
    classFormControl: 'form-control',
    classFormCounter: 'form-counter',
    classFormError: 'form-errors',
    classFormHelp: 'form-help',
    classFormRequired: 'form-required',
    classIconBase: 'far',
    requiredString: '*',
    maxLengthString: 'Noch %s Zeichen',
    minLengthString: 'Es fehlen noch %s Zeichen',
    readonlyString: 'Readonly mode',
    counterBefore: true
};
class FormUtilitiesModule {
    static forRoot(options = DefaultFormUtilitiesOptions) {
        return {
            ngModule: FormUtilitiesModule,
            providers: [
                FormErrorService,
                { provide: 'FormUtilitiesOptions', useValue: Object.assign({}, DefaultFormUtilitiesOptions, options) || DefaultFormUtilitiesOptions },
                {
                    provide: HTTP_INTERCEPTORS,
                    useClass: FormErrorInterceptor,
                    multi: true
                }
            ]
        };
    }
}
FormUtilitiesModule.ɵfac = function FormUtilitiesModule_Factory(t) { return new (t || FormUtilitiesModule)(); };
FormUtilitiesModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: FormUtilitiesModule });
FormUtilitiesModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            ReactiveFormsModule,
            NgSelectModule,
            TranslateModule,
            TooltipModule,
            PopoverModule,
            BsDatepickerModule,
            TimepickerModule,
            TextareaAutosizeModule,
            QuillModule
        ], NgSelectModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormUtilitiesModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    NgSelectModule,
                    TranslateModule,
                    TooltipModule,
                    PopoverModule,
                    BsDatepickerModule,
                    TimepickerModule,
                    TextareaAutosizeModule,
                    QuillModule
                ],
                declarations: [
                    InputComponent,
                    DatepickerComponent,
                    DaterangeComponent,
                    TextareaComponent,
                    RteComponent,
                    SelectDirective,
                    ProgressButtonComponent,
                    CheckboxComponent,
                    DatetimepickerComponent,
                    RadioComponent,
                    MaxLengthDirective,
                    FormLabelComponent,
                    FormLabelIconComponent,
                    FormErrorsComponent,
                    FormHelpComponent,
                    FormTipsComponent,
                    FormRequiredComponent,
                    FormCounterComponent,
                    FormAddonComponent,
                    FormReadonlyLabelComponent,
                    TimepickerComponent
                ],
                exports: [
                    NgSelectModule,
                    InputComponent,
                    DatepickerComponent,
                    DaterangeComponent,
                    TextareaComponent,
                    RteComponent,
                    SelectDirective,
                    ProgressButtonComponent,
                    CheckboxComponent,
                    DatetimepickerComponent,
                    RadioComponent,
                    MaxLengthDirective,
                    FormLabelComponent,
                    FormLabelIconComponent,
                    FormErrorsComponent,
                    FormHelpComponent,
                    FormTipsComponent,
                    FormRequiredComponent,
                    FormCounterComponent,
                    FormAddonComponent,
                    TimepickerComponent,
                    FormReadonlyLabelComponent,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FormUtilitiesModule, { declarations: function () { return [InputComponent, DatepickerComponent, DaterangeComponent, TextareaComponent, RteComponent, SelectDirective, ProgressButtonComponent, CheckboxComponent, DatetimepickerComponent, RadioComponent, MaxLengthDirective, FormLabelComponent, FormLabelIconComponent, FormErrorsComponent, FormHelpComponent, FormTipsComponent, FormRequiredComponent, FormCounterComponent, FormAddonComponent, FormReadonlyLabelComponent, TimepickerComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgSelectModule,
        TranslateModule,
        TooltipModule,
        PopoverModule,
        BsDatepickerModule,
        TimepickerModule,
        TextareaAutosizeModule,
        QuillModule]; }, exports: function () { return [NgSelectModule, InputComponent, DatepickerComponent, DaterangeComponent, TextareaComponent, RteComponent, SelectDirective, ProgressButtonComponent, CheckboxComponent, DatetimepickerComponent, RadioComponent, MaxLengthDirective, FormLabelComponent, FormLabelIconComponent, FormErrorsComponent, FormHelpComponent, FormTipsComponent, FormRequiredComponent, FormCounterComponent, FormAddonComponent, TimepickerComponent, FormReadonlyLabelComponent]; } }); })();

const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const isEmail = (c) => {
    return EMAIL_REGEX.test(c.value) ? null : { email: true };
};

/**
 * Generated bundle index. Do not edit.
 */

export { DatepickerComponent, DaterangeComponent, DefaultFormUtilitiesOptions, FormErrorService, FormUtilitiesModule, InputComponent, ProgressButtonComponent, SelectDirective, TextareaComponent, isEmail, FormInputComponent as ɵb, RteComponent as ɵc, CheckboxComponent as ɵd, DatetimepickerComponent as ɵe, RadioComponent as ɵf, MaxLengthDirective as ɵg, FormLabelComponent as ɵh, FormLabelIconComponent as ɵi, FormErrorsComponent as ɵj, FormHelpComponent as ɵk, FormTipsComponent as ɵl, FormRequiredComponent as ɵm, FormCounterComponent as ɵn, FormAddonComponent as ɵo, FormReadonlyLabelComponent as ɵp, TimepickerComponent as ɵq, FormErrorInterceptor as ɵr };

